/**
 * Ruscha tarjimalar.
 *
 * Kalit = O'ZBEKCHA MANBA MATN (`src/lib/i18n/index.ts` ga qarang).
 * Bu yerda bo'lmagan kalit uchun o'zbekcha matnning o'zi ko'rsatiladi — ekran
 * hech qachon buzilmaydi, faqat o'sha satr tarjimasiz qoladi.
 *
 * Yangi matn qo'shganda: kodda `t('Yangi matn')` deb yozing va shu faylga
 * `'Yangi matn': 'Новый текст',` qatorini qo'shing. Boshqa hech narsa kerak emas.
 *
 * Ko'plik shakllari `|` bilan ajratiladi (1 | 2-4 | 5+) va `{count}` parametriga
 * qarab avtomatik tanlanadi, masalan:
 *   '{count} ta do'kon': '{count} магазин|{count} магазина|{count} магазинов'
 */
export const ru: Record<string, string> = {
  '"{name}" do\'konini o\'chirishni xohlaysizmi?': 'Удалить магазин «{name}»?',
  '(+) Umumiy tushum': '(+) Общая выручка',
  '(Limit 2/2 to‘lgan)': '(Лимит 2/2 заполнен)',
  '(Sotuvchi)': '(Продавец)',
  '(−) Brak non zarari': '(−) Убыток от брака',
  '(−) Masalliq sarfi (Tannarx)': '(−) Расход ингредиентов (себестоимость)',
  '(−) Operatsion xarajatlar': '(−) Операционные расходы',
  '(−) Vazvrat zarari': '(−) Убыток от возвратов',
  '+ Masalliq qo\'shish': '+ Добавить ингредиент',
  '+ Non qo\'shish': '+ Добавить хлеб',
  '+ Qo‘shish': '+ Добавить',
  '+ Xarajat': '+ Расход',
  '+ Yangi do\'kon qo\'shish': '+ Добавить магазин',
  '+ Yangi foydalanuvchi': '+ Новый пользователь',
  '+ Yangi mahsulot': '+ Новый продукт',
  '+ Yangi masalliq qo\'shish': '+ Добавить ингредиент',
  '+ Yangi masalliq': '+ Новый ингредиент',
  '+ Yangi novvoyxona': '+ Новая пекарня',
  '+ Yangi yetkazish (buyurtmasiz)': '+ Новая доставка (без заказа)',
  '-- Dastavshik tanlang (ixtiyoriy) --': '-- Выберите доставщика (необязательно) --',
  '/ dona': '/ шт',
  '1 dona narxi': 'Цена за 1 шт',
  '1 dona tannarx:': 'Себестоимость 1 шт:',
  '1 dona': '1 шт',
  '1 hafta': '1 неделя',
  '1 qop narxi': 'Цена 1 мешка',
  '1 qop un (50 kg) uchun masalliqlar normasi:': 'Норма ингредиентов на 1 мешок муки (50 кг):',
  '1 qop un og\'irligi (kg)': 'Вес 1 мешка муки (кг)',
  '1 qopdan chiqadigan zuvala (dona) *': 'Заготовок из 1 мешка (шт) *',
  '1 qopdan chiqish:': 'Выход с 1 мешка:',
  '20 dona sutli non': '20 шт молочного хлеба',
  '24 soat': '24 часа',
  '3 kun': '3 дня',
  '3 oy': '3 месяца',
  '40 dona yog\'li non': '40 шт сдобного хлеба',
  '7 kun': '7 дней',
  'Admin (Tizim boshqaruvchisi)': 'Админ (управляющий системой)',
  'Admin Kassa Amallari': 'Кассовые операции админа',
  'Admin sessiyasiga qaytdingiz': 'Вы вернулись в сессию администратора',
  'Admin': 'Админ',
  'Adminga qaytish': 'Вернуться в админа',
  'ADMINGA YUBORISH': 'ОТПРАВИТЬ АДМИНУ',
  'Administrator Profili': 'Профиль администратора',
  'Administrator sizga rol biriktirgach tizimga kira olasiz. Odatda 1 ish kuni.': 'Вы сможете войти после того, как администратор назначит вам роль. Обычно 1 рабочий день.',
  'Administrator tasdiqlagach sizga xabar beramiz': 'Мы сообщим вам после подтверждения администратором',
  'Administrator': 'Администратор',
  'Administratorga xabar berildi': 'Администратор уведомлён',
  'Adminlar': 'Админы',
  'Agent (Do\'kon jalb qiluvchi)': 'Агент (привлекает магазины)',
  'Agent buyurtma bera olmaydi': 'Агент не может оформлять заказы',
  'Agent': 'Агент',
  'Agent:': 'Агент:',
  'Agentlar ({n})': 'Агенты ({n})',
  'Ajoyib!': 'Отлично!',
  'Akkaunt holati': 'Статус аккаунта',
  'Akkountga kirib bo‘lmadi': 'Не удалось войти в аккаунт',
  'Almashtirish': 'Заменить',
  'Amallar →': 'Действия →',
  'Ariza qabul qilindi': 'Заявка принята',
  'Arizalar': 'Заявки',
  'Arizalarni yuklashda xatolik yuz berdi': 'Ошибка при загрузке заявок',
  'Arizani rad etish': 'Отклонить заявку',
  'arizasini rad etish sababini kiriting. Ushbu sabab agentga ko\'rsatiladi.': 'укажите причину отклонения заявки. Эта причина будет показана агенту.',
  'Aslida nechta qoldi?': 'Сколько осталось фактически?',
  'Asosiy ma\'lumotlar va joylashuv': 'Основные данные и местоположение',
  'Asosiy navigatsiya': 'Основная навигация',
  'Asosiy un qopi (1 qop)': 'Основной мешок муки (1 мешок)',
  'Asosiy Un qopi:': 'Основной мешок муки:',
  'Assalomu alaykum,': 'Здравствуйте,',
  'Audit jurnali': 'Журнал аудита',
  'Avval masalliqlar bazasida masalliq qo\'shing': 'Сначала добавьте ингредиенты в базу ингредиентов',
  'Avto': 'Авто',
  'baho': 'оценка',
  'Baholaganingiz uchun rahmat!': 'Спасибо за вашу оценку!',
  'baholang': 'оцените',
  'Baholar': 'Оценки',
  'Baholash uchun buyurtma topilmadi': 'Заказ для оценки не найден',
  'Baholash': 'Оценка',
  'Baholashda xatolik yuz berdi': 'Ошибка при оценке',
  'Balans:': 'Баланс:',
  'Barcha amallar serverga muvaffaqiyatli yetkazilgan.': 'Все операции успешно отправлены на сервер.',
  'Barcha arizalar ko\'rib chiqilgan yoki tasdiqlangan': 'Все заявки рассмотрены или подтверждены',
  'Barcha chiqimlar bilan': 'Со всеми расходами',
  'Barcha hisobotlar': 'Все отчёты',
  'Barcha mahsulotlar qo\'shilgan': 'Все продукты добавлены',
  'Barcha mahsulotlar savatdan o\'chiriladi. Davom etasizmi?': 'Все продукты будут удалены из корзины. Продолжить?',
  'Barcha moliyaviy hisobotlar': 'Все финансовые отчёты',
  'Barcha novvoyxonalar': 'Все пекарни',
  'Barchasi →': 'Все →',
  'Barchasi': 'Все',
  'Barchasini ko\'rish ({n})': 'Смотреть все ({n})',
  'Barchasini ko\'rish': 'Смотреть все',
  'Batafsil ko\'rish': 'Смотреть подробнее',
  'Batafsil ko‘rish →': 'Смотреть подробнее →',
  'Batafsil →': 'Подробнее →',
  'Batafsil': 'Подробнее',
  'Bekor qilish': 'Отмена',
  'Belgini (emoji) o\'zgartirish uchun bosing': 'Нажмите, чтобы изменить значок (эмодзи)',
  'Belgini (emoji) tanlash': 'Выбрать значок (эмодзи)',
  'Belgini o\'zgartirish uchun ustiga bosing': 'Нажмите на значок, чтобы изменить его',
  'Berildi (do\'konlarga)': 'Выдано (магазинам)',
  'Berildi': 'Выдано',
  'Berilgan non:': 'Выдано хлеба:',
  'Bildirish': 'Уведомить',
  'Bildirishnoma yo\'q': 'Нет уведомлений',
  'Bildirishnomalar ochildi': 'Уведомления открыты',
  'Bildirishnomalar': 'Уведомления',
  'Bio': 'О себе',
  'Bir qismi naqd': 'Частично наличными',
  'Biriktirilgan do\'konlar ({n})': 'Закреплённые магазины ({n})',
  'Biriktirilgan hudud': 'Закреплённый район',
  'Biriktirilmagan': 'Не закреплён',
  'Birinchi buyurtmangizdan so\'ng bu yerda ko\'rinadi': 'Появится здесь после вашего первого заказа',
  'Birlik': 'Единица',
  'Bo\'lishi kerak': 'Должно быть',
  'Bor': 'Есть',
  'bosganda': 'при нажатии',
  'Bosh sahifa': 'Главная',
  'Bosh sahifaga qaytish': 'Вернуться на главную',
  'Bosh sahifaga': 'На главную',
  'Boshlang\'ich kassa': 'Начальная касса',
  'Boshlang\'ich': 'Начальный',
  'Boshlanish sanasi': 'Дата начала',
  'Boshlanish vaqti': 'Время начала',
  'Boshqa admin nomidan kirib bo‘lmaydi': 'Нельзя войти от имени другого администратора',
  'Boshqa non turini qo\'shish:': 'Добавить другой вид хлеба:',
  'Boshqa sana': 'Другая дата',
  'Boshqa vaqt': 'Другое время',
  'Boshqa xarajatlar': 'Прочие расходы',
  'Boshqa': 'Другое',
  'Boshqaruv paneli': 'Панель управления',
  'Boshqaruv Paneli': 'Панель управления',
  'Bosib, sonni to\'g\'ridan-to\'g\'ri kiriting': 'Нажмите и введите количество вручную',
  'Botni ulash': 'Подключить бота',
  'Botni ulashda xatolik': 'Ошибка подключения бота',
  'Brak %': 'Брак %',
  'Brak (Hisobdan chiqarildi)': 'Брак (списано)',
  'Brak kiritish': 'Внести брак',
  'Brak muvaffaqiyatli qayd etildi': 'Брак успешно зафиксирован',
  'Brak ogohlantirish (%)': 'Предупреждение о браке (%)',
  'Brak soni ishlab chiqarilgandan ko‘p': 'Количество брака больше произведённого',
  'Brak soni': 'Количество брака',
  'Brak zarari': 'Убыток от брака',
  'Brak': 'Брак',
  'brak': 'брак',
  'Brak:': 'Брак:',
  'Brakni saqlashda xatolik yuz berdi': 'Ошибка при сохранении брака',
  'Bu amalga ruxsatingiz yo‘q': 'У вас нет прав на это действие',
  'Bu bo\'limga ruxsatingiz yo\'q': 'У вас нет доступа к этому разделу',
  'Bu buyurtma bugungi ro\'yxatda yo\'q yoki allaqachon yopilgan bo\'lishi mumkin.': 'Этого заказа нет в сегодняшнем списке или он уже закрыт.',
  'Bu davr uchun ma\'lumot topilmadi.': 'Данные за этот период не найдены.',
  'Bu do\'kon sizga biriktirilmagan yoki topilmadi.': 'Этот магазин не закреплён за вами или не найден.',
  'Bu mahsulot hozircha tugagan': 'Этот продукт временно закончился',
  'Bu mahsulotga novvoyxona narxi kiritilmagan — do‘kon narxi ishlatilmoqda': 'Для этого продукта не указана цена пекарни — используется цена магазина',
  'Bu novvoyxona uchun hali smena ochilmagan.': 'Для этой пекарни смена ещё не открывалась.',
  'Bu novvoyxona uchun hali vazvrad qayd etilmagan.': 'Для этой пекарни возвраты ещё не фиксировались.',
  'Bu novvoyxona uchun hali xarajat qayd etilmagan.': 'Для этой пекарни расходы ещё не фиксировались.',
  'Bu novvoyxona uchun masalliq qoldig\'i topilmadi.': 'Остатки ингредиентов для этой пекарни не найдены.',
  'Bu novvoyxonaga biriktirilgan do\'kon topilmadi.': 'Магазины, закреплённые за этой пекарней, не найдены.',
  'Bu oy': 'Этот месяц',
  'Bu qurilmada joylashuvni aniqlash ishlamaydi. Xaritadan qo‘lda belgilang.': 'На этом устройстве определение местоположения не работает. Отметьте вручную на карте.',
  'Bu raqamga klient akkaunti yaratiladi': 'На этот номер будет создан клиентский аккаунт',
  'Bu telefon raqam allaqachon ro‘yxatdan o‘tgan': 'Этот номер телефона уже зарегистрирован',
  'Bugun allaqachon baholagansiz': 'Вы уже оценили сегодня',
  'Bugun chiqim': 'Расход за сегодня',
  'Bugun dona': 'Сегодня, шт',
  'Bugun ishlab chiqarildi': 'Произведено сегодня',
  'Bugun kirim': 'Приход за сегодня',
  'Bugun olindi': 'Получено сегодня',
  'Bugun qo\'lingizda': 'Сегодня у вас на руках',
  'Bugun sotildi': 'Продано сегодня',
  'Bugun': 'Сегодня',
  'BUGUN': 'СЕГОДНЯ',
  'Bugungi buyurtma dedlayni': 'Дедлайн сегодняшнего заказа',
  'Bugungi buyurtmalar': 'Сегодняшние заказы',
  'Bugungi buyurtmalari bo\'yicha kerak:': 'Требуется по сегодняшним заказам:',
  'Bugungi natija': 'Итог за сегодня',
  'Bugungi non': 'Хлеб на сегодня',
  'Bugungi smenalar': 'Сегодняшние смены',
  'Bugungi tushum': 'Выручка за сегодня',
  'Bunday hisobot mavjud emas': 'Такого отчёта не существует',
  'BUYURTMA BERISH': 'ОФОРМИТЬ ЗАКАЗ',
  'Buyurtma holati bu amalga mos emas': 'Статус заказа не подходит для этого действия',
  'Buyurtma izohini kiriting': 'Введите комментарий к заказу',
  'Buyurtma qabul qilindi': 'Заказ принят',
  'Buyurtma qoidalari': 'Правила заказа',
  'Buyurtma talabi va izoh *': 'Требование к заказу и комментарий *',
  'Buyurtma topilmadi': 'Заказ не найден',
  'Buyurtma': 'Заказ',
  'buyurtma': 'заказ',
  'Buyurtmadan keyin': 'После заказа',
  'Buyurtmadan': 'От заказа',
  'Buyurtmadek': 'Как в заказе',
  'Buyurtmaga qarab to\'ldir': 'Заполнить по заказу',
  'Buyurtmalar topilmadi': 'Заказы не найдены',
  'Buyurtmalar yuklanmadi': 'Заказы не загружены',
  'Buyurtmalar': 'Заказы',
  'Buyurtmalarim': 'Мои заказы',
  'BUYURTMANI KUZATISH': 'ОТСЛЕДИТЬ ЗАКАЗ',
  'Buyurtmani yuklab bo\'lmadi. Internet aloqasini tekshirib, qayta urinib ko\'ring.': 'Не удалось загрузить заказ. Проверьте интернет-соединение и попробуйте снова.',
  'Ch': 'Ср',
  'Chakana narx (so\'m)': 'Розничная цена (сум)',
  'Chakana savdo': 'Розничная продажа',
  'Chakana sotildi': 'Продано в розницу',
  'Chakana sotuv': 'Розничная продажа',
  'Chek biriktirildi': 'Чек прикреплён',
  'Chek rasmi': 'Фото чека',
  'Chek rasmini olish / biriktirish': 'Снять / прикрепить фото чека',
  'Chek yuklanmoqda...': 'Чек загружается...',
  'Cheklovchi:': 'Ограничитель:',
  'CHIQADIGAN NON': 'ВЫХОД ХЛЕБА',
  'Chiqdi': 'Выход',
  'Chiqim yozish': 'Записать расход',
  'Chiqish': 'Выйти',
  'Chorak': 'Квартал',
  'dan': 'с',
  'Daromad va Foyda tahlili': 'Анализ доходов и прибыли',
  'Daromad va xarajat moddalari, summa va tushumdagi ulushi (%)': 'Статьи доходов и расходов, сумма и доля в выручке (%)',
  'Dashboard': 'Дашборд',
  'Dastavshik (biriktirish)': 'Доставщик (закрепление)',
  'Dastavshik (Kuryer) biriktirish': 'Закрепить доставщика (курьера)',
  'Dastavshik': 'Доставщик',
  'Dastavshik: Biriktirilmagan': 'Доставщик: не закреплён',
  'Dastavshik:': 'Доставщик:',
  'Davr xulosasi': 'Итоги периода',
  'Dinamika': 'Динамика',
  'Dispatch yaratishda xatolik yuz berdi': 'Ошибка при создании отгрузки',
  'Do\'kon #{id}': 'Магазин №{id}',
  'Do\'kon administratorga yuboriladi. Tasdiqlangach sizga bildirishnoma xabari keladi.': 'Магазин будет отправлен администратору. После подтверждения вы получите уведомление.',
  'Do\'kon arizalari ({n})': 'Заявки магазинов ({n})',
  'Do\'kon arizalari': 'Заявки магазинов',
  'Do\'kon arizasi rad etildi': 'Заявка магазина отклонена',
  'Do\'kon egasi yoki sotuvchi ma\'lumotlari': 'Данные владельца или продавца магазина',
  'Do\'kon faol': 'Магазин активен',
  'Do\'kon faolligi': 'Активность магазина',
  'Do\'kon haqida': 'О магазине',
  'Do\'kon ma\'lumotlari yangilandi': 'Данные магазина обновлены',
  'Do\'kon ma\'lumotlarini o\'zgartirish uchun agent yoki novvoyxona bilan bog\'laning.': 'Для изменения данных магазина свяжитесь с агентом или пекарней.',
  'Do\'kon ma\'lumotlarini yuklashda xatolik yuz berdi': 'Ошибка при загрузке данных магазина',
  'Do\'kon muvaffaqiyatli qo\'shildi': 'Магазин успешно добавлен',
  'Do\'kon muvaffaqiyatli tasdiqlandi': 'Магазин успешно подтверждён',
  'Do\'kon muvaffaqiyatli yuborildi': 'Магазин успешно отправлен',
  'Do\'kon narxi (so\'m) *': 'Цена для магазина (сум) *',
  'do\'kon narxi': 'цена магазина',
  'Do\'kon narxi:': 'Цена для магазина:',
  'Do\'kon nima, qancha va qachon olishini yozing. Bu ma\'lumot novvoyxonaga yuboriladi.': 'Укажите, что, сколько и когда получает магазин. Эта информация будет отправлена в пекарню.',
  'Do\'kon nomi *': 'Название магазина *',
  'Do\'kon nomi yoki manzil...': 'Название магазина или адрес...',
  'Do\'kon nomi': 'Название магазина',
  'Do\'kon nomini kiriting': 'Введите название магазина',
  'Do\'kon o\'chirildi': 'Магазин удалён',
  'do\'kon qizil zonada': 'магазин в красной зоне',
  'do\'kon qo\'shildi': 'магазин добавлен',
  'Do\'kon qo\'shildi': 'Магазин добавлен',
  'Do\'kon qo\'shish': 'Добавить магазин',
  'Do\'kon qo\'shishda xatolik yuz berdi': 'Ошибка при добавлении магазина',
  'Do\'kon rasmi': 'Фото магазина',
  'Do\'kon rasmini yuklang': 'Загрузите фото магазина',
  'Do\'kon sotish:': 'Продажи магазина:',
  'Do\'kon tahrirlandi va qayta yuborildi': 'Магазин отредактирован и отправлен повторно',
  'Do\'kon tanlang': 'Выберите магазин',
  'Do\'kon tasdiqlandi': 'Магазин подтверждён',
  'Do\'kon topilmadi': 'Магазин не найден',
  'Do\'kon yangi qarzi:': 'Новый долг магазина:',
  'Do\'kon yangilandi': 'Магазин обновлён',
  'Do\'kon yoki izoh bo\'yicha qidirish...': 'Поиск по магазину или комментарию...',
  'Do\'kon yoki manzil qidirish...': 'Поиск магазина или адреса...',
  'Do\'kon yuborildi': 'Магазин отправлен',
  'do\'kon': 'магазин',
  'Do\'kon': 'Магазин',
  'Do\'kon, manzil yoki sotuvchini qidirish...': 'Поиск магазина, адреса или продавца...',
  'Do\'kon, novvoyxona, buyurtmalar soni, non miqdori, savdo summasi, qarz, vazvrad foizi va agent': 'Магазин, пекарня, количество заказов, объём хлеба, сумма продаж, долг, процент возвратов и агент',
  'Do\'kon, novvoyxona, qarz summasi, zona, oxirgi to\'lov sanasi, o\'tgan kunlar, agent va dostavshik': 'Магазин, пекарня, сумма долга, зона, дата последней оплаты, прошло дней, агент и доставщик',
  'Do\'konga topshirish': 'Передать магазину',
  'do\'konini rostdan ham o\'chirmoqchimisiz? Bu amalni ortga qaytarib bo\'lmaydi.': 'действительно хотите удалить этот магазин? Это действие необратимо.',
  'Do\'konlar reytingi': 'Рейтинг магазинов',
  'Do\'konlar ro\'yxatini yuklab bo\'lmadi': 'Не удалось загрузить список магазинов',
  'Do\'konlar ro\'yxatini yuklab bo\'lmadi. Internet aloqasini tekshirib, qayta urinib ko\'ring.': 'Не удалось загрузить список магазинов. Проверьте интернет-соединение и попробуйте снова.',
  'Do\'konlar sharhlari': 'Отзывы магазинов',
  'Do\'konlar topilmadi': 'Магазины не найдены',
  'Do\'konlar va Qarzlar': 'Магазины и долги',
  'Do\'konlar va qarzlar': 'Магазины и долги',
  'Do\'konlar yo\'q': 'Магазинов нет',
  'Do\'konlar': 'Магазины',
  'Do\'konlardan qaytgan eskirgan nonlar qiymati': 'Стоимость чёрствого хлеба, возвращённого из магазинов',
  'Do\'konlarim qarzi': 'Долг моих магазинов',
  'Do\'konlarim': 'Мои магазины',
  'Do\'konlarimga': 'В мои магазины',
  'Do\'konlarni ko\'rish': 'Смотреть магазины',
  'Do\'konlarni yuklab bo\'lmadi': 'Не удалось загрузить магазины',
  'Do\'konni o\'chirish': 'Удалить магазин',
  'Do\'konni o\'chirishda xatolik': 'Ошибка при удалении магазина',
  'Do\'konni tahrirlash': 'Редактировать магазин',
  'Do\'konni yangilashda xatolik': 'Ошибка при обновлении магазина',
  'Do\'konning qarzi kamayadi': 'Долг магазина уменьшится',
  'Dona (DONA)': 'Штука (DONA)',
  'dona bilan yuborish': 'отправить, шт',
  'dona bor': 'шт в наличии',
  'dona chiqdi': 'шт выпущено',
  'dona kam': 'шт не хватает',
  'Dona narxi:': 'Цена за штуку:',
  'dona non qaytarildi': 'шт хлеба возвращено',
  'dona non': 'шт хлеба',
  'dona sof non': 'шт чистого хлеба',
  'dona': 'шт',
  'Dostavshik (Haydovchi)': 'Доставщик (водитель)',
  'Dostavshik (Kuryer)': 'Доставщик (курьер)',
  'Dostavshik (Yetkazib beruvchi)': 'Доставщик (перевозчик)',
  'Dostavshik aniqlanmadi': 'Доставщик не определён',
  'Dostavshik do‘konga olib boradigan narx': 'Цена, по которой доставщик везёт в магазин',
  'Dostavshik kelganda pulni topshiring — u ilovada qayd etadi va qarzingiz darhol kamayadi.': 'Передайте деньги доставщику при его приезде — он отметит это в приложении, и ваш долг сразу уменьшится.',
  'Dostavshik': 'Доставщик',
  'dostavshik': 'доставщик',
  'Dostavshikda bugungi buyurtmalar mavjud emas': 'У доставщика нет заказов на сегодня',
  'Dostavshikdan qabul qilindi': 'Принято от доставщика',
  'Dostavshikka yuborish': 'Отправить доставщику',
  'Dostavshikka': 'Доставщику',
  'Dostavshiklar ({n})': 'Доставщики ({n})',
  'Dostavshiklar samaradorligi': 'Эффективность доставщиков',
  'Dostavshiklar': 'Доставщики',
  'Dostavshiklarga': 'Доставщикам',
  'Dostavshiklarga:': 'Доставщикам:',
  'Dostavshikni tanlang': 'Выберите доставщика',
  'Do‘kon nomini kiriting': 'Введите название магазина',
  'Do‘kon qizil zonada — tasdiq talab qilinadi': 'Магазин в красной зоне — требуется подтверждение',
  'Du': 'Пн',
  'E\'tibor talab qiladi ({n})': 'Требует внимания ({n})',
  'Ehtiyot bo‘ling': 'Будьте внимательны',
  'Eng faol do\'konlarim': 'Мои самые активные магазины',
  'Ertaga {date}': 'Завтра, {date}',
  'Ertangi buyurtma': 'Заказ на завтра',
  'Excel hisobot yuklab olindi (stub)': 'Excel-отчёт загружен (заглушка)',
  'Excel yuklab olish': 'Скачать Excel',
  'Excel': 'Excel',
  'Familiya *': 'Фамилия *',
  'Familiya': 'Фамилия',
  'Familiyani kiriting': 'Введите фамилию',
  'Familya *': 'Фамилия *',
  'Familya': 'Фамилия',
  'Familyangizni kiriting': 'Введите вашу фамилию',
  'Familyani kiriting': 'Введите фамилию',
  'Faol bo\'lmasa tizimga kira olmaydi': 'Если неактивен — не сможет войти в систему',
  'Faol bo\'lsa buyurtma bera oladi': 'Если активен — может оформлять заказы',
  'Faol holatda yaratish': 'Создать активным',
  'faol mahsulot · Klient katalogida ko\'rinadi': 'активный продукт · виден в каталоге клиента',
  'Faol masalliq': 'Активный ингредиент',
  'Faol': 'Активен',
  'Faollik': 'Активность',
  'Faqat ish kunlari': 'Только рабочие дни',
  'Farq bo‘lganda izoh kiritish majburiy!': 'При наличии расхождения комментарий обязателен!',
  'Farq nima sababdan yuzaga kelganini yozing...': 'Опишите причину расхождения...',
  'Farq yo\'q (to\'g\'ri)': 'Расхождений нет (верно)',
  'Farq:': 'Разница:',
  'Fayl hajmi 10 MB dan oshmasligi kerak': 'Размер файла не должен превышать 10 МБ',
  'Fikringizni yozing...': 'Напишите ваш отзыв...',
  'Filial kassa balansini boshqarish': 'Управление балансом кассы филиала',
  'Formula tarkibi (Yoqish / O\'chirish)': 'Состав формулы (включить / выключить)',
  'Foyda va zarar': 'Прибыль и убытки',
  'Foyda': 'Прибыль',
  'Foydalanuvchi faolligi': 'Активность пользователя',
  'Foydalanuvchi ma’lumotlari yangilandi': 'Данные пользователя обновлены',
  'Foydalanuvchi o‘chirildi': 'Пользователь удалён',
  'Foydalanuvchi yaratildi': 'Пользователь создан',
  'Foydalanuvchi:': 'Пользователь:',
  'Foydalanuvchilar ro\'yxatini yuklab bo\'lmadi': 'Не удалось загрузить список пользователей',
  'Foydalanuvchilar topilmadi': 'Пользователи не найдены',
  'Foydalanuvchilar': 'Пользователи',
  'Foydalanuvchini nofaol qilish': 'Деактивировать пользователя',
  'Foydalanuvchini yangilashda xatolik': 'Ошибка при обновлении пользователя',
  'ga yetkazildi!': 'доставлено!',
  'gacha': 'до',
  'Galereya': 'Галерея',
  'Google Xaritada ochish': 'Открыть в Google Картах',
  'Google Xaritada tekshirish ↗': 'Проверить в Google Картах ↗',
  'Gramm (G)': 'Грамм (G)',
  'Ha (Qop)': 'Да (мешок)',
  'Ha, beraman': 'Да, выдам',
  'Hafta': 'Неделя',
  'Haftalik': 'За неделю',
  'Hali harakat yo\'q': 'Пока нет операций',
  'Hali izoh yo\'q': 'Пока нет отзывов',
  'Hali mahsulot qo\'shilmagan': 'Продукты ещё не добавлены',
  'Hammasi ({n})': 'Все ({n})',
  'Hammasi': 'Всё',
  'Hammasini topshirish': 'Сдать всё',
  'Har kuni avtomatik buyurtma': 'Ежедневный автоматический заказ',
  'Har kuni': 'Каждый день',
  'Har kuni:': 'Ежедневно:',
  'Har qopdan necha zuvala?': 'Сколько заготовок с одного мешка?',
  'Har safar nima kerak': 'Что нужно каждый раз',
  'Harakat tarixi': 'История операций',
  'Harakatlar tarixi': 'История операций',
  'Harakatlar topilmadi': 'Операции не найдены',
  'Harakatlar yo\'q': 'Операций нет',
  'Harakatlar': 'Операции',
  'Harakatlarim (Tarix)': 'Мои операции (история)',
  'Harakatlarim tarixi': 'История моих операций',
  'Hisob': 'Счёт',
  'Hisob-kitob qanday ishlaydi?': 'Как выполняется расчёт?',
  'Hisob:': 'Расчёт:',
  'Hisobingiz bormi?': 'Уже есть аккаунт?',
  'Hisobingiz yo\'qmi?': 'Нет аккаунта?',
  'Hisoblangan natija': 'Результат расчёта',
  'Hisobni tahrirlash': 'Редактировать аккаунт',
  'Hisobot & tahlil': 'Отчёты и аналитика',
  'Hisobot topilmadi': 'Отчёт не найден',
  'Hisobot': 'Отчёт',
  'Hisobotga o\'tish →': 'Перейти к отчёту →',
  'hisoboti': 'отчёт',
  'Hisobotlar': 'Отчёты',
  'Hisobvaraqlardagi naqd pul': 'Наличные на счетах',
  'Holat o‘zgartirildi': 'Статус изменён',
  'Holat': 'Статус',
  'Holati:': 'Статус:',
  'Hozir yuborish': 'Отправить сейчас',
  'hozir': 'только что',
  'Hozircha bu bo\'limda hech qanday do\'kon mavjud emas': 'В этом разделе пока нет ни одного магазина',
  'Hozircha chiqimlar mavjud emas': 'Расходов пока нет',
  'Hozircha faol buyurtma yo\'q': 'Активных заказов пока нет',
  'Hozircha harakat yo\'q': 'Операций пока нет',
  'Hozircha kirimlar mavjud emas.': 'Приходов пока нет.',
  'Hozircha qarzi bor do\'kon topilmadi.': 'Магазинов с долгом пока не найдено.',
  'Hozircha tizimda birorta ham novvoyxona mavjud emas': 'В системе пока нет ни одной пекарни',
  'Hozircha retsept bo\'sh. Pastdagi tugma orqali masalliq qo\'shing.': 'Рецепт пока пуст. Добавьте ингредиенты с помощью кнопки ниже.',
  'Hozirgi balans:': 'Текущий баланс:',
  'Huquqlar darajasi': 'Уровень прав',
  'Idish & Jihoz': 'Тара и инвентарь',
  'Iltimos, rad etish sababini kiriting': 'Пожалуйста, укажите причину отклонения',
  'Iltimos, Telegram bot tokenni kiriting': 'Пожалуйста, введите токен Telegram-бота',
  'Interaktiv formula kalkulyatori': 'Интерактивный калькулятор формулы',
  'Interfeys tili': 'Язык интерфейса',
  'Internet aloqasi yo‘q. Qayta urinib ko‘ring': 'Нет интернет-соединения. Попробуйте снова',
  'Internet yo\'q': 'Нет интернета',
  'Internet yo‘q': 'Нет интернета',
  'Ish boshlanishi': 'Начало работы',
  'Ish haqi, ijara, yoqilg\'i, kommunal chiqimlar': 'Зарплата, аренда, топливо, коммунальные расходы',
  'Ish tugashi': 'Окончание работы',
  'Ish vaqti (dan)': 'Часы работы (с)',
  'Ish vaqti (gacha)': 'Часы работы (до)',
  'Ish vaqti noaniq': 'Часы работы не указаны',
  'Ish vaqti': 'Часы работы',
  'Ish vaqti:': 'Часы работы:',
  'Ishlab chiq.': 'Произв.',
  'Ishlab chiqarildi': 'Произведено',
  'Ishlab chiqarildi:': 'Произведено:',
  'Ishlab chiqarish dinamikasi': 'Динамика производства',
  'Ishlab chiqarish va novvoyxona': 'Производство и пекарня',
  'Ishlab chiqarish va partiyalarni kiritish uchun yangi smena oching.': 'Откройте новую смену, чтобы вносить производство и партии.',
  'Ishlab chiqarish': 'Производство',
  'Ishlab chiqarishdagi chiqimlar': 'Расходы на производство',
  'Ishlatildi:': 'Использовано:',
  'Ishlatilgan un va masalliqlar': 'Использованная мука и ингредиенты',
  'Ishlatilgan': 'Использовано',
  'Ism *': 'Имя *',
  'Ism va familyani kiriting': 'Введите имя и фамилию',
  'Ism yoki telefon bo\'yicha qidirish...': 'Поиск по имени или телефону...',
  'Ism': 'Имя',
  'Ism, familya yoki telefon orqali qidirish...': 'Поиск по имени, фамилии или телефону...',
  'Ism, novvoyxona, yetkazdi, jami summa, naqd, nasiya, vazvrad foizi, reyting va kassa': 'Имя, пекарня, доставлено, общая сумма, наличные, в долг, процент возвратов, рейтинг и касса',
  'Ismingizni kiriting': 'Введите ваше имя',
  'Ismni kiriting': 'Введите имя',
  'Ixtiyoriy': 'Необязательно',
  'Izoh (ixtiyoriy)': 'Комментарий (необязательно)',
  'Izoh (ixtiyoriy)...': 'Комментарий (необязательно)...',
  'Izoh': 'Комментарий',
  'Izohlar': 'Комментарии',
  'Jami chiqdi': 'Всего выпущено',
  'Jami daromad': 'Общий доход',
  'Jami javobgarlik': 'Общая ответственность',
  'Jami Kassa': 'Всего в кассе',
  'Jami kirim summasi:': 'Общая сумма прихода:',
  'Jami qarz': 'Общий долг',
  'Jami summa': 'Общая сумма',
  'Jami summa:': 'Общая сумма:',
  'Jami summani kiriting — son avtomatik hisoblanadi': 'Введите общую сумму — количество рассчитается автоматически',
  'Jami yetkazilmoqda:': 'Всего доставляется:',
  'Jami': 'Итого',
  'Jami:': 'Итого:',
  'JAMI:': 'ИТОГО:',
  'Joriy GPS lokatsiya olindi': 'Текущая GPS-локация получена',
  'Joriy joyim': 'Моё текущее местоположение',
  'Joriy joylashuv olindi': 'Текущее местоположение получено',
  'Joriy joylashuv': 'Текущее местоположение',
  'Joriy parol': 'Текущий пароль',
  'Joriy parolingizni kiriting': 'Введите ваш текущий пароль',
  'Joriy parolni kiriting': 'Введите текущий пароль',
  'Joriy qarz': 'Текущий долг',
  'Joriy qarz:': 'Текущий долг:',
  'Joylashuv aniqlanmadi — signal kuchsiz. Xaritadan qo‘lda belgilang.': 'Местоположение не определено — слабый сигнал. Отметьте вручную на карте.',
  'Joylashuvga ruxsat berilmagan. Telegram sozlamalarida ilovaga lokatsiya ruxsatini yoqing yoki xaritadan qo‘lda belgilang.': 'Доступ к местоположению запрещён. Включите разрешение на локацию в настройках Telegram или отметьте точку на карте вручную.',
  'Joylashuvni aniqlab bo‘lmadi. Xaritadan qo‘lda belgilang.': 'Не удалось определить местоположение. Отметьте вручную на карте.',
  'Ju': 'Пт',
  'Juda ko‘p so‘rov, biroz kuting': 'Слишком много запросов, подождите немного',
  'Juda yaxshi': 'Очень хорошо',
  'Kam qoldi': 'Мало осталось',
  'Kam qolgan / Tugagan': 'Заканчивается / закончилось',
  'Kam qolgan masalliqlar ({n})': 'Заканчивающиеся ингредиенты ({n})',
  'Kamera': 'Камера',
  'Kamida 4 ta belgi': 'Минимум 4 символа',
  'Kamida 6 belgi, 1 harf va 1 raqam': 'Минимум 6 символов, 1 буква и 1 цифра',
  'Kamida 6 ta belgi (harf va raqam)': 'Минимум 6 символов (буквы и цифры)',
  'Kamida 800×800 px, oq fonda, yaxshi yorug\'likda olingan rasm yuklang.': 'Загрузите изображение минимум 800×800 px, на белом фоне, при хорошем освещении.',
  'Kamida bitta mahsulot miqdorini kiriting!': 'Укажите количество хотя бы одного продукта!',
  'Kamida bitta non miqdorini kiriting': 'Укажите количество хотя бы для одного вида хлеба',
  'Kassa (so\'m)': 'Касса (сум)',
  'Kassa amali muvaffaqiyatli bajarildi': 'Кассовая операция успешно выполнена',
  'Kassa amalida xatolik yuz berdi': 'Ошибка при выполнении кассовой операции',
  'Kassa amallari': 'Кассовые операции',
  'Kassa balansi': 'Баланс кассы',
  'Kassa balansidan xarajat sifatida ayriladi': 'Вычитается из баланса кассы как расход',
  'Kassa balansini to‘g‘rilash': 'Корректировка баланса кассы',
  'Kassa qoldig\'i': 'Остаток в кассе',
  'Kassa rasxodlari': 'Расходы кассы',
  'Kassa va boshqaruv': 'Касса и управление',
  'Kassa': 'Касса',
  'Kassada bo\'ladi:': 'Будет в кассе:',
  'Kassada qoladi:': 'Останется в кассе:',
  'Kassada yetarli pul yo‘q': 'В кассе недостаточно денег',
  'Kassadan pul yechish': 'Снятие денег из кассы',
  'Kassadan qarz mablag‘i berish': 'Выдача заёмных средств из кассы',
  'Kassadan to\'landi': 'Оплачено из кассы',
  'Kassadan yechish': 'Снять из кассы',
  'Kassadan': 'Из кассы',
  'Kassaga naqd pul kiritish': 'Внесение наличных в кассу',
  'Kassaga naqd pul': 'Наличные в кассу',
  'Kassangizdan naqd pul berasiz': 'Вы выдаёте наличные из своей кассы',
  'Kassangizni topshirish yoki kun yakuni sverkasi qiling.': 'Сдайте кассу или проведите сверку по итогам дня.',
  'Katalog yuklanmadi': 'Каталог не загружен',
  'Katalogda hali mahsulotlar yaratilmagan': 'В каталоге пока не создано ни одного продукта',
  'Katalogda ko\'rsatish': 'Показывать в каталоге',
  'Katalogda 🤍 ustiga bosib mahsulot qo\'shing': 'Добавьте продукт, нажав 🤍 в каталоге',
  'Katalogdan non tanlang va birinchi buyurtmangizni bering': 'Выберите хлеб в каталоге и оформите свой первый заказ',
  'Katalogga non va retsept qo\'shish': 'Добавить хлеб и рецепт в каталог',
  'Katalogga o\'tish': 'Перейти в каталог',
  'Katalogga qaytish': 'Вернуться в каталог',
  'Kategoriya': 'Категория',
  'Kech keldi': 'Приехал поздно',
  'kecha': 'вчера',
  'Kecha': 'Вчера',
  'KECHA': 'ВЧЕРА',
  'Kechagi kundan qolgan non, bugun ishlab chiqarilgani, sotilgani va kun oxiridagi qoldiq': 'Остаток со вчерашнего дня, произведено сегодня, продано и остаток на конец дня',
  'Kechagi qoldiq': 'Остаток со вчера',
  'Kelgan': 'Поступило',
  'Kenglik (Lat)': 'Широта (Lat)',
  'Kerak:': 'Требуется:',
  'Keyingi balans:': 'Следующий баланс:',
  'Keyingi manzil': 'Следующий адрес',
  'Keyingi manzilga o\'tish': 'Перейти к следующему адресу',
  'KEYINGISI': 'ДАЛЕЕ',
  'Keyingisi:': 'Следующий:',
  'Kilogramm (KG)': 'Килограмм (KG)',
  'Kimga?': 'Кому?',
  'Kimgadir topshirdingizmi? (Izoh)': 'Кому передали? (Комментарий)',
  'Kirim kiritish': 'Внести приход',
  'Kirim muvaffaqiyatli saqlandi': 'Приход успешно сохранён',
  'Kirim qo\'shish': 'Добавить приход',
  'Kirimlar tarixi': 'История приходов',
  'Kirimni saqlashda xatolik yuz berdi': 'Ошибка при сохранении прихода',
  'Kirish sahifasiga': 'На страницу входа',
  'Kirish': 'Войти',
  'Klient (Do\'kon egasi)': 'Клиент (владелец магазина)',
  'Klient akkaunti yaratildi': 'Клиентский аккаунт создан',
  'Klient akkaunti yaratish': 'Создать клиентский аккаунт',
  'Klient katalogida ko\'rinadi (Faol)': 'Виден в каталоге клиента (активен)',
  'Klient': 'Клиент',
  'Klientga ushbu ma\'lumotlarni yetkazing:': 'Передайте клиенту эти данные:',
  'Ko\'p marta xato kiritildi. 15 daqiqadan keyin urinib ko\'ring.': 'Слишком много неверных попыток. Попробуйте через 15 минут.',
  'Ko\'paytirish': 'Увеличить',
  'Ko\'proq yuklash': 'Загрузить ещё',
  'Ko\'r →': 'Смотреть →',
  'Ko\'rinish': 'Внешний вид',
  'Ko\'rish →': 'Смотреть →',
  'Ko\'rish': 'Смотреть',
  'Ko\'rsatilmagan': 'Не указано',
  'Konfliktni hal qilish': 'Разрешить конфликт',
  'Ko‘p marta xato kiritildi, 15 daqiqadan keyin urinib ko‘ring': 'Слишком много неверных попыток, попробуйте через 15 минут',
  'Ko‘rinish': 'Внешний вид',
  'Kun boshida': 'На начало дня',
  'kun oldin': 'дн. назад',
  'Kun oxiri qoldiq': 'Остаток на конец дня',
  'Kun progressi': 'Прогресс дня',
  'Kun yakuni sverkasi': 'Сверка по итогам дня',
  'Kun yakuni': 'Итоги дня',
  'Kunda o\'rtacha': 'В среднем в день',
  'Kunduzgi smena ochish': 'Открыть дневную смену',
  'Kunduzgi smena': 'Дневная смена',
  'Kunduzgi': 'Дневная',
  'Kunduzi': 'Днём',
  'Kunlar bo\'yicha umumiy savdo tushumi': 'Общая выручка по дням',
  'Kunlik non balansi': 'Дневной баланс хлеба',
  'Kunlik summa:': 'Сумма за день:',
  'Kunlik yetkazishlar dinamikasi (dona)': 'Динамика доставок по дням (шт)',
  'Kutil.': 'Ожид.',
  'Kutilayotgan arizalar yo\'q': 'Нет ожидающих заявок',
  'Kutilayotgan buyurtma:': 'Ожидаемый заказ:',
  'Kutilayotgan do\'konlarni tasdiqlash': 'Подтверждение ожидающих магазинов',
  'Kutilayotgan foyda (farq):': 'Ожидаемая прибыль (разница):',
  'Kutilayotgan talab:': 'Ожидаемая потребность:',
  'Kutilmoqda ({n})': 'Ожидают ({n})',
  'Kutilmoqda': 'Ожидается',
  'Limit': 'Лимит',
  'Limit:': 'Лимит:',
  'Litr (L)': 'Литр (L)',
  'Lokatsiya (GPS koordinatalar)': 'Локация (GPS-координаты)',
  'Lokatsiyani aniqlab bo‘lmadi': 'Не удалось определить местоположение',
  'Lokatsiyani aniqlab bo‘lmadi, standart koordinata olindi': 'Не удалось определить местоположение, взяты координаты по умолчанию',
  'Ma\'lumot mos kelmadi': 'Данные не совпали',
  'Ma\'lumot topilmadi': 'Данные не найдены',
  'Ma\'lumotlar noto\'g\'ri': 'Некорректные данные',
  'Ma\'lumotlar yangilandi': 'Данные обновлены',
  'Mahsulot #{id}': 'Продукт №{id}',
  'Mahsulot & Retsept': 'Продукт и рецепт',
  'Mahsulot nomi *': 'Название продукта *',
  'Mahsulot o\'chirildi': 'Продукт удалён',
  'Mahsulot qo\'shish': 'Добавить продукт',
  'Mahsulot qo\'shishda xatolik yuz berdi': 'Ошибка при добавлении продукта',
  'Mahsulot rasmi': 'Фото продукта',
  'Mahsulot yangilandi': 'Продукт обновлён',
  'Mahsulot': 'Продукт',
  'Mahsulotlar hali qo\'shilmagan': 'Продукты ещё не добавлены',
  'Mahsulotlar mavjud emas': 'Продуктов нет',
  'Mahsulotlar va masalliqlar': 'Продукты и ингредиенты',
  'Mahsulotlar yo\'q': 'Продуктов нет',
  'Mahsulotlar': 'Продукты',
  'Mahsulotlar:': 'Продукты:',
  'Mahsulotlarni yuklab bo\'lmadi': 'Не удалось загрузить продукты',
  'Mahsulotni tahrirlash': 'Редактировать продукт',
  'Maksimal 2 ta admin bo‘lishi mumkin': 'Может быть максимум 2 админа',
  'Maksimal 2 ta admin. Yangi admin qo\'shish uchun mavjud admin akkauntini o\'chirish yoki rolni o\'zgartirish kerak.': 'Максимум 2 админа. Чтобы добавить нового, удалите существующий аккаунт админа или измените его роль.',
  'Maksimal': 'Максимум',
  'Manfiy novvoyxona qoldig\'iga ruxsat': 'Разрешить отрицательный остаток в пекарне',
  'Manzil *': 'Адрес *',
  'Manzil kiritilmagan': 'Адрес не указан',
  'Manzil noto\'g\'ri': 'Некорректный адрес',
  'Manzil va lokatsiya': 'Адрес и местоположение',
  'Manzil:': 'Адрес:',
  'Manzilni kiriting': 'Введите адрес',
  'Manzilni o‘zgartirish uchun agentga murojaat qiling': 'Для изменения адреса обратитесь к агенту',
  'Marja:': 'Маржа:',
  'marta urindi': 'попыток',
  'Masalan: 123456 yoki yangi parol': 'Например: 123456 или новый пароль',
  'Masalan: 5 yillik tajriba, Andijon tumani bo\'yicha ishlayman': 'Например: 5 лет опыта, работаю по Андижанскому району',
  'Masalan: Baraka Market': 'Например: Baraka Market',
  'Masalan: Do\'kon manzili noto\'g\'ri ko\'rsatilgan...': 'Например: неверно указан адрес магазина...',
  'Masalan: Har kuni ertalab 8:00 gacha 40 dona yog\'li non, 15 dona sutli non oladi...': 'Например: каждый день до 8:00 берёт 40 шт сдобного хлеба и 15 шт молочного...',
  'Masalan: Kunjut, Mak, Shakar': 'Например: кунжут, мак, сахар',
  'Masalan: Masalliq xaridi uchun avans berildi...': 'Например: выдан аванс на закупку ингредиентов...',
  'Masalan: Orqa eshikdan kirasiz...': 'Например: вход через заднюю дверь...',
  'Masalan: Sardor Yusupovga berdim...': 'Например: передал Сардору Юсупову...',
  'Masalliq #{id}': 'Ингредиент №{id}',
  'Masalliq (Rasxod)': 'Ингредиент (расход)',
  'Masalliq belgisi (Emoji)': 'Значок ингредиента (эмодзи)',
  'Masalliq belgisini (emoji) tanlang': 'Выберите значок ингредиента (эмодзи)',
  'Masalliq kirimi': 'Приход ингредиентов',
  'Masalliq miqdori 0 dan katta bo\'lishi kerak': 'Количество ингредиента должно быть больше 0',
  'Masalliq nomi *': 'Название ингредиента *',
  'Masalliq nomi, birligi, novvoyxona, boshlang\'ich, kelgan, ishlatilgan, qolgan, qiymati va holat': 'Название ингредиента, единица, пекарня, начальный остаток, поступило, использовано, осталось, стоимость и статус',
  'Masalliq nomini kiriting': 'Введите название ингредиента',
  'Masalliq o\'chirildi / faolsizlantirildi': 'Ингредиент удалён / деактивирован',
  'Masalliq qo\'shishda xatolik yuz berdi': 'Ошибка при добавлении ингредиента',
  'Masalliq sarfi (avtomatik)': 'Расход ингредиентов (автоматически)',
  'Masalliq sarfi (Tannarx)': 'Расход ингредиентов (себестоимость)',
  'Masalliq tannarxi:': 'Себестоимость ингредиентов:',
  'Masalliq turlari': 'Виды ингредиентов',
  'Masalliq xaridi': 'Закупка ингредиентов',
  'Masalliq yangilandi': 'Ингредиент обновлён',
  'Masalliq yetarli emas': 'Недостаточно ингредиентов',
  'Masalliq': 'Ингредиент',
  'Masalliqlar bazasi ({n})': 'База ингредиентов ({n})',
  'Masalliqlar bazasida masalliq mavjud emas. Avval \'Masalliqlar bazasi\' bo\'limida masalliq qo\'shing.': 'В базе ингредиентов нет записей. Сначала добавьте ингредиенты во вкладке «База ингредиентов».',
  'Masalliqlar qoldig\'i': 'Остаток ингредиентов',
  'Masalliqlar topilmadi': 'Ингредиенты не найдены',
  'Masalliqlar yo\'q': 'Ингредиентов нет',
  'Masalliqlar': 'Ингредиенты',
  'Masalliqlarni yuklab bo\'lmadi': 'Не удалось загрузить ингредиенты',
  'Masalliqni o\'chirishda xatolik yuz berdi': 'Ошибка при удалении ингредиента',
  'Masalliqni tahrirlash': 'Редактировать ингредиент',
  'Mavjud': 'В наличии',
  'Mavjud:': 'В наличии:',
  'Mavzu (tema)': 'Тема оформления',
  'Men haqimda': 'О себе',
  'Menejer': 'Менеджер',
  'Mening kassam': 'Моя касса',
  'Mening statistikam': 'Моя статистика',
  'Mijoz': 'Клиент',
  'Mijozlar & qarzlar': 'Клиенты и долги',
  'Mijozlar umumiy qarzi': 'Общий долг клиентов',
  'Min. Zaxira:': 'Мин. запас:',
  'min:': 'мин:',
  'MiniApp (Platforma) URL': 'URL MiniApp (платформы)',
  'MiniApp URL https:// bilan boshlanishi kerak': 'URL MiniApp должен начинаться с https://',
  'Miqdor': 'Количество',
  'Miqdorni to\'g\'ridan-to\'g\'ri kiritish uchun bosing': 'Нажмите, чтобы ввести количество вручную',
  'Modda': 'Статья',
  'Munosabat yomon': 'Плохое отношение',
  'Muomalasi yomon': 'Плохое обращение',
  'Naqd to\'langan summa:': 'Оплачено наличными:',
  'Naqd to\'liq': 'Полностью наличными',
  'Naqd to‘lov': 'Оплата наличными',
  'Naqd': 'Наличные',
  'Narx': 'Цена',
  'Narx:': 'Цена:',
  'Nasiya (qarz)': 'В долг (задолженность)',
  'Nasiya va hisobot': 'Долги и отчётность',
  'Nasiya': 'В долг',
  'Navbat bo\'sh': 'Очередь пуста',
  'Navbatdagilar ({n})': 'В очереди ({n})',
  'Necha qop un?': 'Сколько мешков муки?',
  'Nechta?': 'Сколько?',
  'ni baholang': 'оцените',
  'ni tashkil etmoqda.': 'составляет.',
  'Nima olmoqchi?': 'Что хотите получить?',
  'Nima yuboriladi?': 'Что отправляется?',
  'Nofaol foydalanuvchi nomidan kirib bo‘lmaydi': 'Нельзя войти от имени неактивного пользователя',
  'Nomaʻlum': 'Неизвестно',
  'Nomi, manzili yoki telefon orqali qidirish...': 'Поиск по названию, адресу или телефону...',
  'Nomini kiriting': 'Введите название',
  'Nomsiz do\'kon': 'Магазин без названия',
  'Nomuvofiqlik sababi (izoh majburiy)': 'Причина расхождения (комментарий обязателен)',
  'Non & Oziq-ovqat': 'Хлеб и продукты',
  'Non kam edi': 'Хлеба было мало',
  'Non mahsulotlari ({n})': 'Хлебная продукция ({n})',
  'Non olindi': 'Хлеб получен',
  'non qoldi.': 'хлеба осталось.',
  'Non qoldig\'i yo\'q': 'Остатка хлеба нет',
  'Non savdosi va yetkazishdan tushgan summa': 'Сумма от продажи и доставки хлеба',
  'Non soni': 'Количество хлеба',
  'Non turi': 'Вид хлеба',
  'Non turi, sana, novvoyxona, qop, zuvala/qop, ishlab chiqildi, brak, sof va summa': 'Вид хлеба, дата, пекарня, мешки, заготовок/мешок, произведено, брак, чистый выход и сумма',
  'Non turlari ulushi': 'Доля видов хлеба',
  'Non yaxshi': 'Хлеб хороший',
  'Non yetmadi': 'Хлеба не хватило',
  'Non yuborish': 'Отправить хлеб',
  'Non': 'Хлеб',
  'Nonni novvoyxonaga qaytarish': 'Вернуть хлеб в пекарню',
  'Nonni qaytarishda xatolik yuz berdi': 'Ошибка при возврате хлеба',
  'Noto\'g\'ri yoki mavjud bo\'lmagan do\'kon ID\'si': 'Неверный или несуществующий ID магазина',
  'Noto\'g\'ri yoki mavjud bo\'lmagan novvoyxona ID\'si': 'Неверный или несуществующий ID пекарни',
  'Novvoyxona (Non)': 'Пекарня (хлеб)',
  'Novvoyxona boshqaruvi': 'Управление пекарней',
  'Novvoyxona detali': 'Детали пекарни',
  'Novvoyxona filiali': 'Филиал пекарни',
  'Novvoyxona harakati': 'Движение по пекарне',
  'Novvoyxona ma\'lumotlari hozircha bo\'sh.': 'Данные пекарни пока пусты.',
  'Novvoyxona nomi *': 'Название пекарни *',
  'Novvoyxona nomini kiriting': 'Введите название пекарни',
  'Novvoyxona nonlari': 'Хлеб в пекарне',
  'Novvoyxona qo\'shishda xatolik yuz berdi': 'Ошибка при добавлении пекарни',
  'Novvoyxona tanlansa do\'kon darhol tasdiqlangan (APPROVED) holatda yaratiladi.': 'Если выбрана пекарня, магазин сразу создаётся в подтверждённом статусе (APPROVED).',
  'Novvoyxona tasdiqlagach dostavshik biriktiriladi va sizga xabar beramiz.': 'После подтверждения пекарней будет закреплён доставщик, и мы вам сообщим.',
  'Novvoyxona tez orada katalogni to\'ldiradi': 'Пекарня скоро наполнит каталог',
  'Novvoyxona topilmadi': 'Пекарня не найдена',
  'Novvoyxona': 'Пекарня',
  'Novvoyxona:': 'Пекарня:',
  'Novvoyxonada (dona non)': 'В пекарне (шт хлеба)',
  'Novvoyxonada qoladi:': 'Останется в пекарне:',
  'Novvoyxonada sotish narxi (so\'m)': 'Цена продажи в пекарне (сум)',
  'Novvoyxonada sotish:': 'Продажа в пекарне:',
  'Novvoyxonada yetarli non yo‘q': 'В пекарне недостаточно хлеба',
  'Novvoyxonada': 'В пекарне',
  'Novvoyxonada:': 'В пекарне:',
  'Novvoyxonadagi non qoldig\'i': 'Остаток хлеба в пекарне',
  'Novvoyxonadagi qiymat': 'Стоимость в пекарне',
  'Novvoyxonaga pul topshirish': 'Сдать деньги в пекарню',
  'Novvoyxonaga qaytarish': 'Вернуть в пекарню',
  'NOVVOYXONAGA QAYTARISH': 'ВЕРНУТЬ В ПЕКАРНЮ',
  'Novvoyxonalar ishlab chiqarish va retseptlarida ishlatiladigan barcha xomashyo turlari.': 'Все виды сырья, используемые в производстве и рецептах пекарен.',
  'Novvoyxonalar kesimida': 'В разрезе пекарен',
  'Novvoyxonalar ro\'yxatini yuklab bo\'lmadi': 'Не удалось загрузить список пекарен',
  'Novvoyxonalar topilmadi': 'Пекарни не найдены',
  'Novvoyxonalar': 'Пекарни',
  'Novvoyxonani tanlang — aks holda do\'kon kutish holatida qoladi va bu ro\'yxatda ko\'rinmaydi': 'Выберите пекарню — иначе магазин останется в статусе ожидания и не появится в этом списке',
  'novvoyxonasi': 'пекарня',
  'Nusxa olish': 'Копировать',
  'Nusxalandi': 'Скопировано',
  'O\'chirish': 'Удалить',
  'O\'chirishda xatolik yuz berdi': 'Ошибка при удалении',
  'O\'lchov birligi:': 'Единица измерения:',
  'O\'qildi': 'Прочитано',
  'O\'qilmagan': 'Непрочитанные',
  'O\'rtacha': 'Средне',
  'O\'simlik & Don': 'Растения и зерно',
  'O\'sish dinamikasi': 'Динамика роста',
  'o\'tgan davrga nisbatan': 'по сравнению с прошлым периодом',
  'o\'tgan davrga': 'к прошлому периоду',
  'O\'tgan kun': 'Прошло дней',
  'O\'tish →': 'Перейти →',
  'O\'zgarish faqat': 'Изменение только',
  'O\'zgartir': 'Изменить',
  'O\'zgartirish': 'Изменить',
  'O\'zgartirishlar saqlandi. Administrator tasdiqlash jarayonida yangilangan ma\'lumotlarni ko\'radi.': 'Изменения сохранены. Администратор увидит обновлённые данные при подтверждении.',
  'ochgan': 'открыл',
  'Ochiq smena mavjud emas': 'Открытых смен нет',
  'Ochiq smena yo\'q': 'Нет открытой смены',
  'OCHIQ': 'ОТКРЫТА',
  'Odatda: 60 (oxirgi 10 smena medianasi)': 'Обычно: 60 (медиана последних 10 смен)',
  'Og\'irligi (g)': 'Вес (г)',
  'Ogohlantirish (sariq)': 'Предупреждение (жёлтая)',
  'Ogohlantirish (so\'m)': 'Предупреждение (сум)',
  'Ogohlantirish ({n})': 'Предупреждение ({n})',
  'Oldingi smena yopilmagan': 'Предыдущая смена не закрыта',
  'Olindi (smendan)': 'Получено (со смены)',
  'Olingan pul:': 'Полученные деньги:',
  'Operatsion chiqimlar (ish haqi, ijara)': 'Операционные расходы (зарплата, аренда)',
  'Operatsion foyda': 'Операционная прибыль',
  'Orqaga': 'Назад',
  'orqali': 'через',
  'Oxirgi 50 ta': 'Последние 50',
  'Oxirgi kassa harakatlari': 'Последние операции по кассе',
  'Oxirgi to\'lov': 'Последняя оплата',
  'Oxirgi to\'lov:': 'Последняя оплата:',
  'Oy': 'Месяц',
  'Oylik dinamika (qo\'shilgan do\'konlar)': 'Динамика по месяцам (добавленные магазины)',
  'Oylik taxminan:': 'Примерно за месяц:',
  'Oylik': 'За месяц',
  'Pa': 'Чт',
  'Parol *': 'Пароль *',
  'Parol almashtirildi. Xavfsizlik uchun qayta kiring': 'Пароль изменён. В целях безопасности войдите заново',
  'Parol kamida 4 ta belgi bo‘lishi kerak': 'Пароль должен содержать минимум 4 символа',
  'Parol kamida 4 ta belgidan iborat bo‘lishi kerak': 'Пароль должен состоять минимум из 4 символов',
  'Parol kamida {n} belgidan iborat bo\'lishi kerak': 'Пароль должен состоять минимум из {n} символов',
  'Parol': 'Пароль',
  'Parolingizni kiriting': 'Введите ваш пароль',
  'Parolni almashtirib bo\'lmadi, qayta urinib ko\'ring': 'Не удалось изменить пароль, попробуйте снова',
  'Parolni almashtirish': 'Сменить пароль',
  'Parolni ko‘rsatish': 'Показать пароль',
  'Parolni o\'zgartirish': 'Изменить пароль',
  'Parolni qayta kiriting': 'Введите пароль ещё раз',
  'Parolni saqlash': 'Сохранить пароль',
  'Parolni takrorlash': 'Повторите пароль',
  'Parolni unutdingizmi? Administratorga murojaat qiling': 'Забыли пароль? Обратитесь к администратору',
  'Parolni yangilash': 'Обновить пароль',
  'Parolni yangilashda xatolik yuz berdi': 'Ошибка при обновлении пароля',
  'Parolni yashirish': 'Скрыть пароль',
  'Partiya qo\'shish uchun avval smena ochilishi lozim.': 'Чтобы добавить партию, сначала нужно открыть смену.',
  'PARTIYA QO\'SHISH': 'ДОБАВИТЬ ПАРТИЮ',
  'Partiya qo\'shish': 'Добавить партию',
  'Partiya': 'Партия',
  'Partiyalar ({n})': 'Партии ({n})',
  'Patir non': 'Патыр',
  'Pechdan qabul qilindi': 'Принято из печи',
  'Pishirilgan nonlar soni': 'Количество выпеченного хлеба',
  'Pishirilgan nonlarga sarflangan un va masalliqlar': 'Мука и ингредиенты, израсходованные на выпечку',
  'Pishiriq & Taom': 'Выпечка и блюда',
  'Pishirishda nuqsonli chiqqan nonlar tannarxi': 'Себестоимость брака, полученного при выпечке',
  'Profil muvaffaqiyatli yangilandi': 'Профиль успешно обновлён',
  'Profil rasmi yangilandi': 'Фото профиля обновлено',
  'Profil rasmini o\'zgartirish': 'Изменить фото профиля',
  'Profil yuklanmadi': 'Профиль не загружен',
  'Profil →': 'Профиль →',
  'Profil': 'Профиль',
  'Profilini ochish': 'Открыть его профиль',
  'Profilini tahrirlash': 'Редактировать профиль',
  'Profilni ko\'rish →': 'Смотреть профиль →',
  'Profilni saqlab bo\'lmadi, qayta urinib ko\'ring': 'Не удалось сохранить профиль, попробуйте снова',
  'Profilni tahrirlash': 'Редактировать профиль',
  'Pul berish': 'Выдать деньги',
  'Pul olib qolish': 'Принять деньги',
  'Pul va qarzga ta\'siri yo\'q (1 ga 1 almashuv)': 'Не влияет на деньги и долг (обмен 1 к 1)',
  'Qachongacha to\'xtatamiz?': 'До какого числа приостановить?',
  'Qancha pul berdi?': 'Сколько денег передал?',
  'Qanday hisoblanadi?': 'Как рассчитывается?',
  'Qarz balansi': 'Баланс долга',
  'Qarz balansi:': 'Баланс долга:',
  'Qarz berish': 'Выдать в долг',
  'Qarz chegaralari': 'Границы долга',
  'Qarz chegarasi (so\'m)': 'Граница долга (сум)',
  'Qarz harakatlari tarixi': 'История движения долга',
  'Qarz holati': 'Состояние долга',
  'Qarz limiti (qizil)': 'Лимит долга (красная)',
  'Qarz limiti oshdi': 'Лимит долга превышен',
  'Qarz limiti oshdi, buyurtma berish mumkin emas': 'Лимит долга превышен, оформить заказ невозможно',
  'Qarz limiti oshgani uchun buyurtma bera olmaysiz': 'Вы не можете оформить заказ, так как превышен лимит долга',
  'Qarz limiti': 'Лимит долга',
  'Qarz ma\'lumoti yuklanmadi': 'Данные о долге не загружены',
  'Qarz ma\'lumoti yuklanmadi. Qayta urinish uchun bosing.': 'Данные о долге не загружены. Нажмите, чтобы повторить.',
  'Qarz mablag\'i': 'Сумма долга',
  'QARZ OLDIM': 'ВЗЯЛ В ДОЛГ',
  'Qarz oldim': 'Взял в долг',
  'Qarz olib qolish': 'Принять возврат долга',
  'Qarz summasi': 'Сумма долга',
  'Qarz taqsimoti': 'Распределение долга',
  'Qarz to\'lovi': 'Погашение долга',
  'Qarz': 'Долг',
  'qarz': 'долг',
  'Qarz:': 'Долг:',
  'Qarzdan ayirildi': 'Вычтено из долга',
  'Qarzdor do\'kon yo\'q': 'Магазинов с долгом нет',
  'Qarzdorlarni yuklab bo\'lmadi': 'Не удалось загрузить должников',
  'Qarzga berildi:': 'Выдано в долг:',
  'Qarzga qo\'shildi': 'Добавлено к долгу',
  'Qarzga yoziladi:': 'Записывается в долг:',
  'Qarzga': 'В долг',
  'Qarzim': 'Мой долг',
  'Qarzlar': 'Долги',
  'Qarzni yopish': 'Погасить долг',
  'Qator jami:': 'Итого по строке:',
  'Qaysi kunlar': 'В какие дни',
  'Qaysi non?': 'Какой хлеб?',
  'Qayta kiring': 'Войдите заново',
  'Qayta rasmga olish': 'Переснять',
  'Qayta urinish': 'Повторить',
  'Qaytariladi:': 'К возврату:',
  'Qaytarildi': 'Возвращено',
  'Qaytarilgan qarzni qabul qilish': 'Приём возвращённого долга',
  'Qaytarish': 'Вернуть',
  'Qaytgan nonlar': 'Возвращённый хлеб',
  'Qidiruv bo\'yicha hech qanday do\'kon mos kelmadi.': 'По запросу не найдено ни одного магазина.',
  'Qidiruv bo\'yicha mos keladigan buyurtma yo\'q': 'По запросу подходящих заказов нет',
  'Qidiruv yoki filtr bo\'yicha hech qanday natija chiqmadi': 'По запросу или фильтру ничего не найдено',
  'Qidiruv yoki filtr bo\'yicha hech qanday tasdiqlangan do\'kon topilmadi': 'По запросу или фильтру не найдено подтверждённых магазинов',
  'Qisman': 'Частично',
  'Qiymati': 'Стоимость',
  'Qiymati:': 'Стоимость:',
  'Qizil chegara (buyurtma bloklanadi)': 'Красная граница (заказы блокируются)',
  'Qizil zona ({n})': 'Красная зона ({n})',
  'Qizil zona': 'Красная зона',
  'Qizil zonadagi do\'kon': 'Магазин в красной зоне',
  'Qo\'lida': 'На руках',
  'Qo\'limdagi non qiymati': 'Стоимость хлеба на руках',
  'Qo\'lingizda faqat': 'У вас на руках только',
  'Qo\'lingizda non qolmagan': 'У вас не осталось хлеба',
  'Qo\'lingizda': 'У вас на руках',
  'Qo\'lingizdagi naqd pul:': 'Наличные у вас на руках:',
  'Qo\'lingizdagi qoldiqdan ortiq berib bo\'lmaydi!': 'Нельзя выдать больше, чем есть у вас на руках!',
  'Qo\'llash': 'Применить',
  'Qo\'ng\'iroq qilish': 'Позвонить',
  'Qo\'ng\'iroq': 'Звонок',
  'Qo\'shimcha izoh...': 'Дополнительный комментарий...',
  'Qo\'shish': 'Добавить',
  'Qoladigan qarz:': 'Остаток долга:',
  'Qoldi': 'Осталось',
  'Qoldi:': 'Осталось:',
  'Qoldiq & hisobot': 'Остатки и отчёт',
  'Qoldiq o‘zgardi, sahifani yangilang': 'Остаток изменился, обновите страницу',
  'Qoldiq qiymati': 'Стоимость остатка',
  'Qoldiq yo\'q': 'Остатка нет',
  'Qoldiq:': 'Остаток:',
  'Qoldiqlarni yangilash': 'Обновить остатки',
  'Qolgan': 'Осталось',
  'Qop (QOP)': 'Мешок (QOP)',
  'qop non yopish mumkin': 'мешков можно выпечь',
  'qop un': 'мешков муки',
  'qop': 'мешок',
  'Qop': 'Мешок',
  'qopga o\'tish': 'перейти к мешкам',
  'Qo‘lingizda yetarli non yo‘q': 'У вас на руках недостаточно хлеба',
  'Qurilma sozlamasidan qat’i nazar shu tema ishlatiladi': 'Эта тема будет использоваться независимо от настроек устройства',
  'Rad etildi': 'Отклонено',
  'Rad etilgan ({n})': 'Отклонены ({n})',
  'RAD ETISH': 'ОТКЛОНИТЬ',
  'Rad etish': 'Отклонить',
  'Rad etishda xatolik yuz berdi': 'Ошибка при отклонении',
  'Rad': 'Откл.',
  'Rahmat! Baho yuborildi': 'Спасибо! Оценка отправлена',
  'Rangli shakllar': 'Цветные фигуры',
  'Rasm tanlash': 'Выбрать изображение',
  'Rasm yuklandi': 'Изображение загружено',
  'Rasm yuklanmagan': 'Изображение не загружено',
  'Rasmni almashtirish': 'Заменить изображение',
  'Rasmni o\'zgartirish': 'Изменить изображение',
  'Rasmni qayta ishlashda xatolik yuz berdi': 'Ошибка при обработке изображения',
  'Rasmni yuklashda xatolik yuz berdi': 'Ошибка при загрузке изображения',
  'Rejali buyurtma faol': 'Плановый заказ активен',
  'Rejali buyurtma generatsiya vaqti': 'Время генерации планового заказа',
  'Rejali buyurtma saqlandi': 'Плановый заказ сохранён',
  'Rejali buyurtma sozlang': 'Настройте плановый заказ',
  'Rejali buyurtma': 'Плановый заказ',
  'Retsept (1 qop un uchun)': 'Рецепт (на 1 мешок муки)',
  'Retsept muvaffaqiyatli saqlandi': 'Рецепт успешно сохранён',
  'Retsept va narxlar': 'Рецепт и цены',
  'Retsept yuklanmoqda...': 'Рецепт загружается...',
  'Retseptni o\'zg.': 'Изм. рецепт',
  'Retseptni saqlashda xatolik yuz berdi': 'Ошибка при сохранении рецепта',
  'Retseptda bitta masalliqni bir necha marta tanlab bo\'lmaydi': 'Один и тот же ингредиент нельзя выбирать несколько раз в рецепте',
  'Reyting': 'Рейтинг',
  'Ro\'yxatdan o\'tish': 'Регистрация',
  'Ro\'yxatdan qidirish...': 'Поиск по списку...',
  'Sabab (ixtiyoriy)': 'Причина (необязательно)',
  'Sabab / Izoh *': 'Причина / комментарий *',
  'Sabab / izoh kiritish majburiy': 'Указание причины / комментария обязательно',
  'Sabab': 'Причина',
  'Sabab:': 'Причина:',
  'Sabzavot & Meva': 'Овощи и фрукты',
  'Sahifa topilmadi': 'Страница не найдена',
  'Salom,': 'Привет,',
  'Sana oralig\'i': 'Диапазон дат',
  'Sana tanlash': 'Выбрать дату',
  'Sana': 'Дата',
  'Sana, do\'kon, novvoyxona, dostavshik, mahsulot, miqdor, zarar summasi, sabab va hisob holati': 'Дата, магазин, пекарня, доставщик, продукт, количество, сумма убытка, причина и статус учёта',
  'Sana, do\'kon, novvoyxona, dostavshik, miqdor, umumiy summa, naqd va nasiya to\'lovlar': 'Дата, магазин, пекарня, доставщик, количество, общая сумма, оплата наличными и в долг',
  'Sana, smena turi, zam, novvoyxona, qoplar, ishlab chiqarish, brak, sof, summa, tannarx va foyda': 'Дата, тип смены, зам, пекарня, мешки, производство, брак, чистый выход, сумма, себестоимость и прибыль',
  'Sana, xarajat kategoriyasi, novvoyxona, summa, to\'lovchi va izoh': 'Дата, категория расхода, пекарня, сумма, плательщик и комментарий',
  'Saqlash': 'Сохранить',
  'SAQLASH': 'СОХРАНИТЬ',
  'Sariq chegara (ogohlantirish)': 'Жёлтая граница (предупреждение)',
  'Savat bo\'sh': 'Корзина пуста',
  'Savat yangilandi': 'Корзина обновлена',
  'Savat': 'Корзина',
  'Savatga qo\'shildi': 'Добавлено в корзину',
  'SAVATGA QO\'SHISH': 'ДОБАВИТЬ В КОРЗИНУ',
  'Savatga': 'В корзину',
  'Savatni tozalash': 'Очистить корзину',
  'Savdo agenti': 'Торговый агент',
  'Savdo summasi': 'Сумма продаж',
  'Savdo tushumi': 'Выручка от продаж',
  'Savdo va yetkazish tushumi': 'Выручка от продаж и доставки',
  'Se': 'Вт',
  'Serverda mavjud': 'Есть на сервере',
  'Sessiya tugadi, qayta kiring': 'Сессия истекла, войдите заново',
  'Sevimli mahsulotlar': 'Избранные продукты',
  'Sevimlilar hali yo\'q': 'Избранного пока нет',
  'Sevimlilardan o\'chirish': 'Удалить из избранного',
  'Sevimlilarga qo\'shish': 'Добавить в избранное',
  'Sh': 'Сб',
  'Sharq & Ziravor': 'Восток и специи',
  'Shaxsiy ma\'lumotlar': 'Личные данные',
  'Shirinlik & Qand': 'Сладости и сахар',
  'Sig\'im ma\'lumotini yuklab bo\'lmadi': 'Не удалось загрузить данные о вместимости',
  'Siz kiritgan': 'Вы ввели',
  'Siz oflaynda {a} dona kiritgansiz, lekin serverda hozir faqat {b} dona mavjud.': 'Вы ввели офлайн {a} шт, но на сервере сейчас есть только {b} шт.',
  'Siz {name} sifatida ishlayapsiz': 'Вы работаете как {name}',
  'Sizga biriktirilgan do\'konlar orasida mos keladigani yo\'q.': 'Среди закреплённых за вами магазинов подходящих нет.',
  'Skan': 'Скан',
  'Smena boshqaruvi': 'Управление сменой',
  'SMENA JAMI': 'ИТОГО ПО СМЕНЕ',
  'Smena muvaffaqiyatli yopildi': 'Смена успешно закрыта',
  'Smena ochishda xatolik yuz berdi': 'Ошибка при открытии смены',
  'Smena yopilgach, yangi partiya qo\'shib bo\'lmaydi va hisobot generatsiya qilinadi. Ishonchingiz komilmi?': 'После закрытия смены нельзя будет добавлять партии, и будет сформирован отчёт. Вы уверены?',
  'Smena yopilgan, o‘zgartirib bo‘lmaydi': 'Смена закрыта, изменить нельзя',
  'Smena': 'Смена',
  'Smenada qop hisobida ishlatiladi': 'В смене учитывается в мешках',
  'SMENAGA KIRISH': 'ВОЙТИ В СМЕНУ',
  'Smenalar yo\'q': 'Смен нет',
  'Smenalar': 'Смены',
  'smenalarga ta\'sir qiladi. Eski smenalar o\'zgarmaydi.': 'повлияет на смены. Старые смены не изменятся.',
  'Smenalarni yuklab bo\'lmadi': 'Не удалось загрузить смены',
  'Smenani yopish': 'Закрыть смену',
  'SMENANI YOPISH': 'ЗАКРЫТЬ СМЕНУ',
  'Smenani yopishda xatolik yuz berdi': 'Ошибка при закрытии смены',
  'SMS orqali yuborish (Tez orada)': 'Отправить по SMS (скоро)',
  'so\'m': 'сум',
  'Sof foyda': 'Чистая прибыль',
  'Sof ishlab chiqarilgan non, brak va qaytgan vazvradlar': 'Чистое производство хлеба, брак и возвраты',
  'Sof non': 'Чистый выход хлеба',
  'Sof non:': 'Чистый выход хлеба:',
  'Sof': 'Чистый',
  'Sotiladigan non:': 'Хлеб на продажу:',
  'Sotildi': 'Продано',
  'Sotuvchi familiyasi': 'Фамилия продавца',
  'Sotuvchi familyasi *': 'Фамилия продавца *',
  'Sotuvchi familyasi': 'Фамилия продавца',
  'Sotuvchi familyasini kiriting': 'Введите фамилию продавца',
  'Sotuvchi ism-familiyasini kiriting': 'Введите имя и фамилию продавца',
  'Sotuvchi ismi *': 'Имя продавца *',
  'Sotuvchi ismi': 'Имя продавца',
  'Sotuvchi ismini kiriting': 'Введите имя продавца',
  'Sotuvchi ma\'lumotlari': 'Данные продавца',
  'Sotuvchi va aloqa': 'Продавец и контакты',
  'Sotuvchi:': 'Продавец:',
  'Sotuvni saqlashda xatolik yuz berdi': 'Ошибка при сохранении продажи',
  'Sovuq edi': 'Был холодный',
  'Sozla': 'Настроить',
  'Sozlamalar saqlandi': 'Настройки сохранены',
  'Sozlamalar': 'Настройки',
  'Sozlamalarni saqlashda xatolik yuz berdi': 'Ошибка при сохранении настроек',
  'Sozlamalarni yuklab bo\'lmadi': 'Не удалось загрузить настройки',
  'Sozlash': 'Настроить',
  'Standart minimal zaxira': 'Минимальный запас по умолчанию',
  'Statistika ma\'lumotlarini olishda xatolik yuz berdi': 'Ошибка при получении статистики',
  'Statistika va tahlil': 'Статистика и аналитика',
  'Statistika yo\'q': 'Статистики нет',
  'Statistika': 'Статистика',
  'Statistikani yuklab bo\'lmadi': 'Не удалось загрузить статистику',
  'Summa': 'Сумма',
  'Summani kiriting': 'Введите сумму',
  'SURIB TASDIQLASH': 'ПРОВЕДИТЕ ДЛЯ ПОДТВЕРЖДЕНИЯ',
  'Sutli non': 'Молочный хлеб',
  'Sutli': 'Молочный',
  'Suyuqlik & Yog‘': 'Жидкости и масла',
  'ta amal': 'операций',
  'ta do\'kon': 'магазинов',
  'ta yangi': 'новых',
  'ta yetkazildi': 'доставлено',
  'ta': 'шт',
  'Tabiat & Belgilar': 'Природа и символы',
  'Tahlil ➔': 'Аналитика ➔',
  'TAHRIRLAB QAYTA YUBORISH': 'ОТРЕДАКТИРОВАТЬ И ОТПРАВИТЬ СНОВА',
  'Tahrirlash': 'Редактировать',
  'Takroriy do‘kon': 'Дублирующийся магазин',
  'Takrorlash': 'Повторить',
  'Tanlang': 'Выберите',
  'Tanlangan belgi masalliq kartochkasida va retseptlarda ko\'rinadi': 'Выбранный значок будет виден в карточке ингредиента и в рецептах',
  'Tanlangan davr yoki novvoyxona bo\'yicha yozuvlar yo\'q': 'По выбранному периоду или пекарне записей нет',
  'Tanlangan davr': 'Выбранный период',
  'Tanlangan davrda hech qanday yetkazish yoki qarz to\'lovi amalga oshirilmagan.': 'За выбранный период не было ни доставок, ни погашений долга.',
  'Tanlangan:': 'Выбрано:',
  'tanlangan': 'выбрано',
  'Tannarx (masalliq)': 'Себестоимость (ингредиенты)',
  'Tannarx': 'Себестоимость',
  'Tarix hali bo\'sh': 'История пока пуста',
  'Tarix mavjud emas': 'История отсутствует',
  'Tarkib': 'Состав',
  'Tarqatilmagan yangi non novvoyxona omboriga qaytadi va qayta sotiladi. Eski (vazvrad) non uchun alohida bo‘lim bor.': 'Нераспределённый свежий хлеб возвращается на склад пекарни и продаётся снова. Для чёрствого хлеба (возврата) есть отдельный раздел.',
  'Tasdiq kutilmoqda ({n})': 'Ожидают подтверждения ({n})',
  'Tasdiq kutilmoqda': 'Ожидает подтверждения',
  'Tasdiq.': 'Подтв.',
  'Tasdiqlandi': 'Подтверждено',
  'Tasdiqlangan ({n})': 'Подтверждены ({n})',
  'Tasdiqlangan': 'Подтверждён',
  'Tasdiqlash': 'Подтвердить',
  'TASDIQLASH': 'ПОДТВЕРДИТЬ',
  'Tasdiqlashda xatolik yuz berdi': 'Ошибка при подтверждении',
  'Tavsiya etilgan vaqt oraliqlari:': 'Рекомендуемые интервалы времени:',
  'Taxminiy summa:': 'Примерная сумма:',
  'Tayyor mahsulot': 'Готовая продукция',
  'Tekshiring': 'Проверьте',
  'Telefon *': 'Телефон *',
  'Telefon ishlamaydi': 'Телефон не работает',
  'Telefon raqam *': 'Номер телефона *',
  'Telefon raqam': 'Номер телефона',
  'Telefon raqami *': 'Номер телефона *',
  'Telefon raqamini kiriting': 'Введите номер телефона',
  'Telefon raqamni o\'zgartirish uchun adminga murojaat qiling': 'Для изменения номера телефона обратитесь к администратору',
  'Telefon': 'Телефон',
  'Telefon:': 'Телефон:',
  'Telegram bot orqali foydalanuvchilar': 'Пользователи через Telegram-бота',
  'Telegram Bot Token (@BotFather\'dan)': 'Токен Telegram-бота (от @BotFather)',
  'Telegram Bot va MiniApp sozlamalari': 'Настройки Telegram-бота и MiniApp',
  'Telegram bot uzildi': 'Telegram-бот отключён',
  'Rostdan ham Telegram botni uzmoqchimisiz?': 'Вы действительно хотите отключить Telegram-бота?',
  'Telegram yoki qurilma sozlamasiga moslashadi': 'Подстраивается под настройки Telegram или устройства',
  'Tez qo\'shish:': 'Быстрое добавление:',
  'Tezkor Amallar': 'Быстрые действия',
  'Tezkor amallar': 'Быстрые действия',
  'Tezkor Bo\'limlar': 'Быстрые разделы',
  'Tezkor sabablar:': 'Быстрые причины:',
  'Tezkor': 'Быстро',
  'Tezkor:': 'Быстро:',
  'Tizim Administratori': 'Системный администратор',
  'Tizim audit jurnali': 'Системный журнал аудита',
  'Tizim sozlamalari': 'Системные настройки',
  'Tizim va Xavfsizlik': 'Система и безопасность',
  'Tizim zaxira nusxasi (backup) muvaffaqiyatli yuklab olindi': 'Резервная копия системы успешно загружена',
  'Tizimda hali masalliqlar kiritilmagan': 'В системе ещё не добавлены ингредиенты',
  'Tizimda xatolik': 'Ошибка в системе',
  'Tizimda xatolik. Administratorga murojaat qiling': 'Ошибка в системе. Обратитесь к администратору',
  'Tizimdan chiqildi': 'Вы вышли из системы',
  'Tizimdan chiqish': 'Выйти из системы',
  'Tizimga filial qo\'shish': 'Добавить филиал в систему',
  'Tizimga kiring': 'Войдите в систему',
  'To\'landi (naqd)': 'Оплачено (наличными)',
  'To\'landi': 'Оплачено',
  'To\'lash haqida': 'Об оплате',
  'To\'liq nazorat': 'Полный контроль',
  'To\'liq qarzga': 'Полностью в долг',
  'To\'liq Sof foyda': 'Полная чистая прибыль',
  'To\'liq telefon raqamini kiriting (+998XXXXXXXXX)': 'Введите полный номер телефона (+998XXXXXXXXX)',
  'To\'lov qabul qilindi': 'Оплата принята',
  'To\'lov': 'Оплата',
  'To\'lovchi': 'Плательщик',
  'To\'xtatildi': 'Приостановлено',
  'TO\'XTATISH': 'ПРИОСТАНОВИТЬ',
  'Toifa': 'Категория',
  'Topilmadi': 'Не найдено',
  'topshirdi': 'сдал',
  'Topshirilayotgan summa': 'Сдаваемая сумма',
  'Topshirish': 'Сдать',
  'Topshirishim kerak': 'Я должен сдать',
  'TOPSHIRISHNI TASDIQLASH': 'ПОДТВЕРДИТЬ СДАЧУ',
  'Toza yetkazdi': 'Доставил аккуратно',
  'To‘lov summasi qarzdan ko‘p': 'Сумма оплаты больше долга',
  'To‘q': 'Тёмная',
  'Tugadi': 'Закончилось',
  'Tugagan': 'Закончился',
  'Tugash sanasi': 'Дата окончания',
  'Tugash vaqti': 'Время окончания',
  'Tugmalarni bosing': 'Нажимайте кнопки',
  'Tungi smena ochish': 'Открыть ночную смену',
  'Tungi smena': 'Ночная смена',
  'Tungi': 'Ночная',
  'Tushum (savdo):': 'Выручка (продажи):',
  'Tushum dinamikasi': 'Динамика выручки',
  'Tushum va non ishlab chiqarish hajmi': 'Выручка и объём производства хлеба',
  'Tushum − Xarajatlar (Tannarxsiz)': 'Выручка − расходы (без себестоимости)',
  'Tushum − Xarajatlar': 'Выручка − расходы',
  'Tushum': 'Выручка',
  'Tuzatish (korreksiya)': 'Корректировка',
  'Tuzatish': 'Корректировка',
  'Ulanmagan': 'Не подключено',
  'Ulgurji narx:': 'Оптовая цена:',
  'Ulush %': 'Доля %',
  'Umumiy do\'konlar ro\'yxati': 'Общий список магазинов',
  'Umumiy': 'Общее',
  'Uning ekranlarini ko‘rasiz va nomidan ish qila olasiz. Amal audit jurnaliga yoziladi.': 'Вы увидите его экраны и сможете работать от его имени. Действие записывается в журнал аудита.',
  'Ushbu davr uchun ma\'lumot mavjud emas': 'Данных за этот период нет',
  'Ushbu smenada hali partiya qo\'shilmagan.': 'В этой смене партии ещё не добавлялись.',
  'Ushbu toifada biriktirilgan do\'konlar mavjud emas.': 'В этой категории нет закреплённых магазинов.',
  'Ushbu toifada buyurtmalar yo\'q': 'В этой категории заказов нет',
  'Uzish': 'Отключить',
  'Uzunlik (Lng)': 'Долгота (Lng)',
  'Vaqt zonasi': 'Часовой пояс',
  'Vaqt': 'Время',
  'Vaqtida keldi': 'Приехал вовремя',
  'Vaqtinchalik parol': 'Временный пароль',
  'Vazvrad %': 'Возврат %',
  'Vazvrad (1:1 almashtirildi)': 'Возврат (обмен 1:1)',
  'Vazvrad (qarzdan ayirildi)': 'Возврат (вычтено из долга)',
  'Vazvrad (Qaytarilgan non)': 'Возврат (возвращённый хлеб)',
  'Vazvrad ogohlantirish (%)': 'Предупреждение о возвратах (%)',
  'Vazvrad qo\'shish': 'Добавить возврат',
  'Vazvrad yo\'q (eski yoki buzilgan non olinmadi)': 'Возвратов нет (чёрствый или испорченный хлеб не забирался)',
  'Vazvrad yo\'q': 'Возвратов нет',
  'Vazvrad zarari': 'Убыток от возвратов',
  'Vazvrad': 'Возврат',
  'Vazvrad:': 'Возврат:',
  'Vazvradlarni yuklab bo\'lmadi': 'Не удалось загрузить возвраты',
  'xabari va MiniApp ilovasini ochish inline tugmasi chiqadi.': 'сообщение и inline-кнопка для открытия MiniApp.',
  'Xarajat haqida qisqa ma\'lumot...': 'Краткая информация о расходе...',
  'Xarajat kiritish': 'Внести расход',
  'Xarajat qo\'shish': 'Добавить расход',
  'Xarajat qoplanmoqda': 'Расход покрывается',
  'Xarajat sababi...': 'Причина расхода...',
  'Xarajat yo\'q': 'Расходов нет',
  'Xarajat': 'Расход',
  'Xarajat:': 'Расход:',
  'Xarajatlar': 'Расходы',
  'Xarajatlarni yuklab bo\'lmadi': 'Не удалось загрузить расходы',
  'XARAJATNI SAQLASH': 'СОХРАНИТЬ РАСХОД',
  'Xarajatni saqlashda xatolik yuz berdi': 'Ошибка при сохранении расхода',
  'Xarita': 'Карта',
  'Xaritada ko\'rish': 'Смотреть на карте',
  'Xaritada ko‘rish': 'Смотреть на карте',
  'Xaritada ochish': 'Открыть на карте',
  'Xaritada': 'На карте',
  'Xaritani bosing yoki markerni suring': 'Нажмите на карту или перетащите маркер',
  'Xatolik yuz berdi': 'Произошла ошибка',
  'Xizmat vaqtincha ishlamayapti': 'Сервис временно недоступен',
  'Xodim qo\'shish': 'Добавить сотрудника',
  'Xodim qo\'shishda xatolik yuz berdi': 'Ошибка при добавлении сотрудника',
  'Xodim va kuryerlar': 'Сотрудники и курьеры',
  'Xodim yoki admin qo\'shish': 'Добавить сотрудника или админа',
  'Xodimlar ro\'yxati': 'Список сотрудников',
  'Xodimlar va adminlar': 'Сотрудники и админы',
  'Xodimlar': 'Сотрудники',
  'Xomashyo qoldig‘i': 'Остаток сырья',
  'Xushmuomala': 'Вежливый',
  'Ya': 'Вс',
  'Yana do\'kon qo\'shish': 'Добавить ещё магазин',
  'Yana masalliq qo\'shish': 'Добавить ещё ингредиент',
  'Yana necha qop yopish mumkin': 'Сколько ещё мешков можно выпечь',
  'Yangi bildirishnomalar shu yerda ko\'rinadi': 'Новые уведомления появятся здесь',
  'Yangi buyurtma vaqtincha bloklandi. To\'lovni dostavshikka topshiring.': 'Новые заказы временно заблокированы. Передайте оплату доставщику.',
  'Yangi do\'kon qo\'shish': 'Добавить новый магазин',
  'YANGI DO\'KON': 'НОВЫЙ МАГАЗИН',
  'Yangi do\'kon': 'Новый магазин',
  'Yangi foydalanuvchi yaratish': 'Создать нового пользователя',
  'Yangi foydalanuvchi': 'Новый пользователь',
  'Yangi mahsulot qo\'shildi': 'Новый продукт добавлен',
  'Yangi mahsulot': 'Новый продукт',
  'Yangi Mahsulot': 'Новый продукт',
  'Yangi masalliq qo\'shildi': 'Новый ингредиент добавлен',
  'Yangi masalliq qo\'shish': 'Добавить новый ингредиент',
  'Yangi masalliq': 'Новый ингредиент',
  'Yangi novvoyxona qo\'shildi': 'Новая пекарня добавлена',
  'Yangi novvoyxona qo\'shish': 'Добавить новую пекарню',
  'Yangi Novvoyxona': 'Новая пекарня',
  'Yangi novvoyxona': 'Новая пекарня',
  'Yangi parol (kamida 6 ta belgi)': 'Новый пароль (минимум 6 символов)',
  'Yangi parol *': 'Новый пароль *',
  'Yangi parol eskisidan farq qilishi kerak': 'Новый пароль должен отличаться от старого',
  'Yangi parol': 'Новый пароль',
  'Yangi parollar mos kelmadi': 'Новые пароли не совпадают',
  'Yangi parolni kiriting': 'Введите новый пароль',
  'Yangi parolni qayta kiriting': 'Введите новый пароль ещё раз',
  'Yangi parolni tasdiqlang': 'Подтвердите новый пароль',
  'Yangi qarz': 'Новый долг',
  'Yangi qo\'shish': 'Добавить новый',
  'Yangi smena ochib partiyalar va ishlab chiqarishni boshlang': 'Откройте новую смену и начните вносить партии и производство',
  'Yangi xodim muvaffaqiyatli qo\'shildi': 'Новый сотрудник успешно добавлен',
  'Yangi xodim qo\'shish': 'Добавить сотрудника',
  'Yangi yetkazish (buyurtmasiz)': 'Новая доставка (без заказа)',
  'Yangi': 'Новый',
  'YANGI': 'НОВЫЙ',
  'Yangilash': 'Обновить',
  'YANGILASH': 'ОБНОВИТЬ',
  'Yangilashda xatolik yuz berdi': 'Ошибка при обновлении',
  'Yangisiga alishtirildi': 'Заменено на новое',
  'Yaratish': 'Создать',
  'Yaratishda xatolik yuz berdi': 'Ошибка при создании',
  'Yashil, sariq va qizil zonalar bo\'yicha': 'По зелёной, жёлтой и красной зонам',
  'Yaxshi ({n})': 'Хорошо ({n})',
  'Yaxshi': 'Хорошо',
  'yetarli emas': 'недостаточно',
  'Yetarli masalliqlar': 'Достаточно ингредиентов',
  'Yetarli': 'Достаточно',
  'Yetkazdi': 'Доставил',
  'YETKAZIB BERDIM': 'Я ДОСТАВИЛ',
  'Yetkazib berildi': 'Доставлено',
  'Yetkazib berish xizmati': 'Служба доставки',
  'YETKAZIB BERISH': 'ДОСТАВКА',
  'Yetkazib berish': 'Доставка',
  'Yetkazib beruvchi nomi...': 'Название поставщика...',
  'Yetkazib beruvchi': 'Поставщик',
  'Yetkazildi': 'Доставлено',
  'Yetkazilgan buyurtmalar shu yerda ko\'rinadi': 'Доставленные заказы появятся здесь',
  'Yetkazilgan non': 'Доставленный хлеб',
  'Yetkazilgan non, reyting ⭐, vazvrad va kunlik dinamika': 'Доставленный хлеб, рейтинг ⭐, возвраты и динамика по дням',
  'Yetkazilgan va hali baholanmagan buyurtmangiz bo\'lishi kerak': 'У вас должен быть доставленный и ещё не оценённый заказ',
  'Yetkazilganlar ({n})': 'Доставлены ({n})',
  'Yetkazish sanasini tanlang': 'Выберите дату доставки',
  'Yetkazish vaqti': 'Время доставки',
  'Yetkazish vaqtini tanlang': 'Выберите время доставки',
  'Yetkazish yoki to\'lov bo\'yicha qo\'shimcha izoh...': 'Дополнительный комментарий по доставке или оплате...',
  'Yetkazish': 'Доставка',
  'Yig\'ilgan naqd': 'Собрано наличными',
  'Yig\'ilgan umumiy tushum': 'Общая собранная выручка',
  'Yil': 'Год',
  'Yo\'q': 'Нет',
  'Yog\'li non': 'Сдобный хлеб',
  'Yog\'li': 'Сдобный',
  'Yoki aniq vaqtni o\'zingiz kiriting:': 'Или введите точное время сами:',
  'Yomon': 'Плохо',
  'YOPILGAN': 'ЗАКРЫТА',
  'yopish mumkin': 'можно выпечь',
  'Yopish': 'Закрыть',
  'Yorug‘': 'Светлая',
  'Yozuvlar soni': 'Количество записей',
  'Yuboriladi:': 'Будет отправлено:',
  'yuborildi': 'отправлено',
  'Yuborilmagan amallar': 'Неотправленные операции',
  'YUBORISH': 'ОТПРАВИТЬ',
  'Yuborishda xatolik yuz berdi. Qayta urinib ko‘ring': 'Ошибка при отправке. Попробуйте снова',
  'Yuborishdan oldin ma\'lumotlarni tekshiring': 'Проверьте данные перед отправкой',
  'Yuklanmadi': 'Не загружено',
  'Yuklanmoqda': 'Загрузка',
  'Yuklanmoqda...': 'Загрузка...',
  'Zam (Menejer)': 'Зам (менеджер)',
  'Zam (Novvoyxona boshqaruvchisi)': 'Зам (управляющий пекарней)',
  'Zam': 'Зам',
  'zam': 'зам',
  'ZAM': 'ЗАМ',
  'Zamlar ({n})': 'Замы ({n})',
  'Zarar:': 'Убыток:',
  'Zaxira nusxa': 'Резервная копия',
  'Zona': 'Зона',
  'zuvala': 'заготовка',
  'Zuvala/qop': 'Заготовок/мешок',
  '{h} soat {m} daqiqa': '{h} ч {m} мин',
  '{name} hisoboti Excel (.xlsx) formatida yuklab olindi': 'Отчёт «{name}» выгружен в формате Excel (.xlsx)',
  '{name} qarz to‘lovi': 'Погашение долга — {name}',
  '{name} sifatida kirdingiz': 'Вы вошли как {name}',
  '{name}ga {n} dona non yuborildi': 'Доставщику {name} отправлено {n} шт хлеба',
  '{n} brak': '{n} брак|{n} брака|{n} браков',
  '{n} daq oldin': '{n} мин назад',
  '{n} daqiqa': '{n} мин',
  '{n} dona non novvoyxonaga qaytarildi': '{n} шт хлеба возвращено в пекарню',
  '{n} dona non novvoyxonaga qo\'shildi': '{n} шт хлеба добавлено в пекарню',
  '{n} dona': '{n} шт',
  '{n} qop': '{n} мешок|{n} мешка|{n} мешков',
  '{n} soat oldin': '{n} ч назад',
  '{n} soat': '{n} ч',
  '{n} xodim': '{n} сотрудник|{n} сотрудника|{n} сотрудников',
  '{n} zuvala': '{n} заготовка|{n} заготовки|{n} заготовок',
  '{type} smena ochildi': '{type} смена открыта',
  '· Qarz to\'lovi': '· Погашение долга',
  '· Yetkazish': '· Доставка',
  '“Sotildi” bo‘limi shu narxni ishlatadi': 'Раздел «Продано» использует эту цену',
  'ℹ️ Har kuni soat 20:00 da ertangi kunga avtomatik buyurtma yaratiladi. Kerak bo\'lsa 20:00 gacha o\'zgartirishingiz mumkin.': 'ℹ️ Каждый день в 20:00 автоматически создаётся заказ на завтра. При необходимости вы можете изменить его до 20:00.',
  'ℹ️ Ushbu amal audit jurnalida qayd etiladi': 'ℹ️ Это действие будет записано в журнал аудита',
  '− Ayirish': '− Вычесть',
  '⌛ Muddati o\'tgan': '⌛ Просрочено',
  '⏳ Kutilmoqda': '⏳ Ожидается',
  '⏸ Vaqtincha to\'xtatish': '⏸ Приостановить',
  '① NECHTA BERDINGIZ?': '① СКОЛЬКО ВЫДАЛИ?',
  '② VAZVRAD (eski non)': '② ВОЗВРАТ (чёрствый хлеб)',
  '③ TO\'LOV': '③ ОПЛАТА',
  '⚙️ Tuzatish (korreksiya)': '⚙️ Корректировка',
  '⚠️ E\'tibor ({n})': '⚠️ Внимание ({n})',
  '⚠️ Konflikt': '⚠️ Конфликт',
  '⚠️ Limit oshadi': '⚠️ Лимит будет превышен',
  '⛔ Bu do\'konning qarzi {sum}. Baribir nasiyaga berasizmi?': '⛔ Долг этого магазина — {sum}. Всё равно выдать в долг?',
  '⛔ Yangi buyurtma bloklangan': '⛔ Новые заказы заблокированы',
  '✅ Kun yakuni sverkasi muvaffaqiyatli tasdiqlandi (oflayn)': '✅ Сверка по итогам дня успешно подтверждена (офлайн)',
  '✅ Kun yakuni sverkasi muvaffaqiyatli tasdiqlandi': '✅ Сверка по итогам дня успешно подтверждена',
  '✅ {sum} qarz to\'lovi qabul qilindi (oflayn)': '✅ Погашение долга на {sum} принято (офлайн)',
  '✅ {sum} qarz to\'lovi qabul qilindi': '✅ Погашение долга на {sum} принято',
  '✅ {sum} topshirildi (tasdiq kutilmoqda)': '✅ Сдано {sum} (ожидает подтверждения)',
  '✍️ Qo\'lda kiritilmoqda — saytda buyurtmasi yo\'q': '✍️ Вводится вручную — заказа на сайте нет',
  '❌ Qayta urinish': '❌ Повторить',
  '⭐ DOSTAVSHIKNI BAHOLASH': '⭐ ОЦЕНИТЬ ДОСТАВЩИКА',
  '🎉 Bugungi barcha buyurtmalar yetkazildi!': '🎉 Все сегодняшние заказы доставлены!',
  '🏭 Novvoyxona:': '🏭 Пекарня:',
  '💡 Qarzni qanday to\'layman?': '💡 Как погасить долг?',
  '💡 Yana ~': '💡 Ещё ~',
  '💳 Do\'kon qarzi:': '💳 Долг магазина:',
  '🔁 Har kuni bir xil olasizmi?': '🔁 Берёте одно и то же каждый день?',
  '🔴 Qizil zona ({n})': '🔴 Красная зона ({n})',
  '🗺 Yo\'l': '🗺 Маршрут',
  '🚀 Yuborilmoqda...': '🚀 Отправляется...',
  '🛵 Biriktirilgan dastavshik:': '🛵 Закреплённый доставщик:',
  '🟡 Ogohlantirish ({n})': '🟡 Предупреждение ({n})',
  '🟢 Yaxshi ({n})': '🟢 Хорошо ({n})',
};
